import { jsx as o, jsxs as C, Fragment as Ze } from "react/jsx-runtime";
import * as v from "react";
import it, { forwardRef as Fe, useRef as le, useEffect as de, useState as he, useLayoutEffect as Ar, createElement as oi, useMemo as ii, Fragment as li, createContext as ci, useContext as si } from "react";
import * as Pn from "react-dom";
import ui, { createPortal as di } from "react-dom";
var De = /* @__PURE__ */ ((e) => (e.Sm = "sm", e.Md = "md", e.Lg = "lg", e.Xl = "xl", e))(De || {}), fi = /* @__PURE__ */ ((e) => (e.Light = "light", e.Dark = "dark", e.Names = "names", e))(fi || {});
const J = (e, t = 16) => `${e / t}rem`;
function kn(e) {
  return Object.entries(e).reduce(
    (r, [n, a]) => (r[n] = `${a}px`, r),
    {}
  );
}
const hi = {
  "iota-primary": {
    0: "#000000",
    10: "#061244",
    20: "#182b8a",
    30: "#3131ff",
    40: "#2563f5",
    50: "#3f80f0",
    60: "#5b9cfe",
    70: "#85b5fb",
    80: "#adceff",
    90: "#d5e8ff",
    100: "#ffffff"
  },
  "iota-secondary": {
    0: "#000000",
    10: "#051631",
    20: "#17345f",
    30: "#2d4c7a",
    40: "#4b648a",
    50: "#637ca2",
    60: "#7e97bd",
    70: "#96b3d5",
    80: "#b6cde8",
    90: "#dde9f7",
    100: "#ffffff"
  },
  "iota-tertiary": {
    0: "#000000",
    10: "#071f22",
    20: "#18393b",
    30: "#185b60",
    40: "#317479",
    50: "#498c91",
    60: "#64a7ac",
    70: "#7fc2c7",
    80: "#9adde2",
    90: "#c2f1f4",
    100: "#ffffff"
  },
  "iota-error": {
    0: "#000000",
    10: "#330009",
    20: "#610012",
    30: "#b51431",
    40: "#ce2d4a",
    50: "#e64562",
    60: "#ff607d",
    70: "#ff889e",
    80: "#ffb0be",
    90: "#ffd9e0",
    100: "#ffffff"
  },
  "iota-neutral": {
    0: "#000000",
    4: "#0a0f17",
    6: "#0f141c",
    10: "#171d26",
    12: "#1c212b",
    20: "#253041",
    30: "#3c4656",
    40: "#545e6e",
    50: "#6e7787",
    60: "#8892a1",
    70: "#a8b2c0",
    80: "#cad4e2",
    90: "#dde4f0",
    92: "#e3eaf6",
    96: "#eff4fa",
    98: "#f8fafc",
    100: "#ffffff"
  },
  "iota-warning": {
    0: "#000000",
    10: "#2D1E00",
    20: "#422C00",
    30: "#674500",
    40: "#8C5D00",
    50: "#A47518",
    60: "#BE8F32",
    70: "#D9AA4D",
    80: "#F4C568",
    90: "#FFE3AB",
    100: "#FFFFFF"
  }
}, mi = {
  "names-primary": {
    0: "#000000",
    10: "#061244",
    20: "#182b8a",
    30: "#3131ff",
    40: "#2563f5",
    50: "#3f80f0",
    60: "#5b9cfe",
    70: "#85b5fb",
    80: "#adceff",
    90: "#d5e8ff",
    100: "#ffffff"
  },
  "names-secondary": {
    0: "#000000",
    10: "#051631",
    20: "#17345f",
    30: "#2d4c7a",
    40: "#4b648a",
    50: "#637ca2",
    60: "#7e97bd",
    70: "#96b3d5",
    80: "#b6cde8",
    90: "#dde9f7",
    100: "#ffffff"
  },
  "names-tertiary": {
    0: "#000000",
    10: "#00231F",
    20: "#00453D",
    30: "#00685C",
    40: "#008C7C",
    50: "#00AF9B",
    60: "#00D7BE",
    70: "#17F3D9",
    80: "#54FFEB",
    90: "#A6FFF4",
    100: "#ffffff"
  },
  "names-error": {
    0: "#000000",
    10: "#3D001F",
    20: "#620432",
    30: "#A30251",
    40: "#C90E6A",
    50: "#DC2B82",
    60: "#E35A9E",
    70: "#EF84B9",
    80: "#FCADD4",
    90: "#FFD7EB",
    100: "#ffffff"
  },
  "names-neutral": {
    0: "#000000",
    4: "#0A0D23",
    6: "#0F1228",
    10: "#181B31",
    12: "#20233C",
    20: "#2B2E45",
    30: "#404359",
    40: "#585B71",
    50: "#71748B",
    60: "#8C8FA5",
    70: "#ACAFC5",
    80: "#CED1E7",
    90: "#DFE2F8",
    92: "#E5E8FE",
    96: "#F0F2FF",
    98: "#F8F9FF",
    100: "#ffffff"
  },
  "names-solid": {
    blue: "#3131FF",
    purple: "#A139FF",
    green: "#14F0D6",
    neutral: "#20233C"
  },
  "names-warning": {
    0: "#000000",
    10: "#2D1E00",
    20: "#422C00",
    30: "#674500",
    40: "#8C5D00",
    50: "#A47518",
    60: "#BE8F32",
    70: "#D9AA4D",
    80: "#F4C568",
    90: "#FFE3AB",
    100: "#FFFFFF"
  }
}, vi = {
  "shader-primary-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-inverted-dark": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7"
  },
  "shader-neutral-dark": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-primary-light": {
    0: "#0067ee00",
    8: "#0067ee14",
    12: "#0067ee1e",
    16: "#0067ee28",
    48: "#0067ee7a",
    72: "#0067eeb7"
  },
  "shader-inverted-light": {
    0: "#bed8ff00",
    8: "#bed8ff14",
    12: "#bed8ff1e",
    16: "#bed8ff28",
    48: "#bed8ff7a",
    72: "#bed8ffb7"
  },
  "shader-neutral-light": {
    0: "#002f6d00",
    8: "#002f6d14",
    12: "#002f6d1e",
    16: "#002f6d28",
    48: "#002f6d7a",
    72: "#002f6db7"
  }
}, gi = {
  none: J(0),
  sm: J(2),
  DEFAULT: J(4),
  md: J(6),
  lg: J(8),
  xl: J(12),
  "2xl": J(16),
  "3xl": J(24),
  full: J(120)
}, pi = {
  none: J(0),
  xxxs: J(2),
  xxs: J(4),
  xs: J(8),
  sm: J(12),
  md: J(16),
  lg: J(24),
  xl: J(32),
  "2xl": J(48)
}, bi = {
  0: "0",
  8: "0.08",
  12: "0.12",
  16: "0.16",
  40: "0.4",
  60: "0.6",
  80: "0.8",
  100: "1"
}, xi = {
  "text-label-sm": [
    "11px",
    {
      lineHeight: "16px",
      letterSpacing: "0.2px",
      fontWeight: 500
    }
  ],
  "text-label-md": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-label-lg": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ]
}, wi = {
  "text-body-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ]
}, yi = {
  "text-body-ds-sm": [
    "12px",
    {
      lineHeight: "16px",
      letterSpacing: "0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-md": [
    "14px",
    {
      lineHeight: "20px",
      letterSpacing: "-0.1px",
      fontWeight: 400
    }
  ],
  "text-body-ds-lg": [
    "16px",
    {
      lineHeight: "24px",
      letterSpacing: "0.2px",
      fontWeight: 400
    }
  ]
}, Si = {
  "text-title-sm": [
    "14px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.1px",
      fontWeight: 500
    }
  ],
  "text-title-md": [
    "16px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.15px",
      fontWeight: 500
    }
  ],
  "text-title-lg": [
    "20px",
    {
      lineHeight: "120%",
      letterSpacing: "-0.4px",
      fontWeight: 500
    }
  ]
}, Ci = {
  "text-headline-sm": [
    "24px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-sm-font-weight)",
      letterSpacing: "-0.2px"
    }
  ],
  "text-headline-md": [
    "28px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-md-font-weight)",
      letterSpacing: "-0.4px"
    }
  ],
  "text-headline-lg": [
    "32px",
    {
      lineHeight: "120%",
      fontWeight: "var(--headline-lg-font-weight)",
      letterSpacing: "-0.4px"
    }
  ]
}, Ei = {
  "text-display-sm": [
    "36px",
    {
      lineHeight: "var(--display-sm-line-height)",
      fontWeight: "var(--display-sm-font-weight)"
    }
  ],
  "text-display-md": [
    "48px",
    {
      lineHeight: "var(--display-md-line-height)",
      fontWeight: "var(--display-md-font-weight)"
    }
  ],
  "text-display-lg": [
    "60px",
    {
      lineHeight: "var(--display-lg-line-height)",
      fontWeight: "var(--display-lg-font-weight)"
    }
  ]
}, Ni = {
  ...xi,
  ...wi,
  ...yi,
  ...Si,
  ...Ci,
  ...Ei
}, _i = Object.entries(Ni).reduce(
  (e, [t, r]) => {
    const n = t.startsWith("text-") ? t.replace("text-", "") : t;
    return { ...e, [n]: r };
  },
  {}
), Mn = {
  "xs--rs": ["4px", "8px"],
  "sm--rs": ["8px", "12px"],
  "md--rs": ["16px", "24px"]
};
function Oi(e, t) {
  const r = [
    De.Sm,
    De.Md,
    De.Lg,
    De.Xl
  ], n = Mn[e];
  let a = `${n[0]}`;
  for (let i = 1; i < n.length; i++)
    if (n[i]) {
      const c = t[r[i]];
      c && (a = `clamp(${a}, (100vw - ${c}) * 99, ${n[i]})`);
    }
  return a;
}
function Ai(e) {
  return Object.keys(Mn).reduce((r, n) => {
    const a = Oi(
      n,
      e
    );
    return {
      ...r,
      [n]: a
    };
  }, {});
}
const Ri = {
  inter: ["Inter", "sans-serif"],
  "alliance-no2": ["AllianceNo2", "sans-serif"],
  "roboto-flex": ["Roboto Flex Variable", "sans-serif"]
}, Di = {
  "default-surface": "var(--default-surface)",
  "on-default": "var(--on-default)",
  "warning-surface": "var(--warning-surface)",
  "on-warning": "var(--on-warning)",
  "error-surface": "var(--error-surface)",
  "on-error": "var(--on-error)",
  "success-surface": "var(--success-surface)",
  "on-success": "var(--on-success)"
};
var kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bn = {}, Fn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  function t(n, a) {
    return {
      handler: n,
      config: a
    };
  }
  t.withOptions = function(n, a = () => ({})) {
    const i = function(c) {
      return {
        __options: c,
        handler: n(c),
        config: a(c)
      };
    };
    return i.__isOptionsFunction = !0, i.__pluginFunction = n, i.__configFunction = a, i;
  };
  const r = t;
})(Fn);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = /* @__PURE__ */ r(Fn);
  function r(a) {
    return a.__esModule ? a : {
      default: a
    };
  }
  const n = t.default;
})(Bn);
let br = Bn;
var Ti = (br.__esModule ? br : { default: br }).default;
const Vn = /* @__PURE__ */ Pr(Ti), Li = Vn(({ addVariant: e }) => {
  e("firefox", "@-moz-document url-prefix()");
}), Ii = Vn(({ addVariant: e }) => {
  e("names", "&:is(.names *)");
}), Pi = {
  "names-gradient-primary": "var(--names-gradient-primary)"
}, Un = {
  content: ["./src/**/*.{html,js,jsx,ts,tsx}"],
  darkMode: "selector",
  plugins: [Li, Ii],
  theme: {
    extend: {
      fontSize: {
        ..._i
      },
      borderRadius: {
        ...gi
      },
      spacing: (e) => {
        const t = e.theme("screens"), r = Ai(t);
        return {
          ...pi,
          ...r
        };
      },
      opacity: {
        ...bi,
        30: "0.3"
      },
      colors: {
        ...hi,
        ...mi,
        ...vi,
        ...Di
      },
      fontFamily: Ri,
      backgroundImage: {
        ...Pi
      }
    }
  }
};
var Zt = { exports: {} };
Zt.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, c = 9007199254740991, s = "[object Arguments]", d = "[object Array]", f = "[object AsyncFunction]", g = "[object Boolean]", h = "[object Date]", x = "[object Error]", w = "[object Function]", y = "[object GeneratorFunction]", p = "[object Map]", S = "[object Number]", E = "[object Null]", D = "[object Object]", N = "[object Proxy]", T = "[object RegExp]", P = "[object Set]", L = "[object String]", _ = "[object Undefined]", I = "[object WeakMap]", k = "[object ArrayBuffer]", q = "[object DataView]", ae = "[object Float32Array]", be = "[object Float64Array]", xe = "[object Int8Array]", Le = "[object Int16Array]", Ve = "[object Int32Array]", F = "[object Uint8Array]", M = "[object Uint8ClampedArray]", X = "[object Uint16Array]", ee = "[object Uint32Array]", re = /[\\^$.*+?()[\]{}|]/g, Q = /^\[object .+?Constructor\]$/, ne = /^(?:0|[1-9]\d*)$/, j = {};
  j[ae] = j[be] = j[xe] = j[Le] = j[Ve] = j[F] = j[M] = j[X] = j[ee] = !0, j[s] = j[d] = j[k] = j[g] = j[q] = j[h] = j[x] = j[w] = j[p] = j[S] = j[D] = j[T] = j[P] = j[L] = j[I] = !1;
  var Je = typeof kt == "object" && kt && kt.Object === Object && kt, Ue = typeof self == "object" && self && self.Object === Object && self, we = Je || Ue || Function("return this")(), et = t && !t.nodeType && t, Ae = et && !0 && e && !e.nodeType && e, Nt = Ae && Ae.exports === et, gt = Nt && Je.process, _t = function() {
    try {
      var l = Ae && Ae.require && Ae.require("util").types;
      return l || gt && gt.binding && gt.binding("util");
    } catch {
    }
  }(), Ot = _t && _t.isTypedArray;
  function or(l, u, m) {
    switch (m.length) {
      case 0:
        return l.call(u);
      case 1:
        return l.call(u, m[0]);
      case 2:
        return l.call(u, m[0], m[1]);
      case 3:
        return l.call(u, m[0], m[1], m[2]);
    }
    return l.apply(u, m);
  }
  function ir(l, u) {
    for (var m = -1, A = Array(l); ++m < l; )
      A[m] = u(m);
    return A;
  }
  function At(l) {
    return function(u) {
      return l(u);
    };
  }
  function lr(l, u) {
    return l == null ? void 0 : l[u];
  }
  function O(l, u) {
    return function(m) {
      return l(u(m));
    };
  }
  var R = Array.prototype, B = Function.prototype, H = Object.prototype, oe = we["__core-js_shared__"], $ = B.toString, V = H.hasOwnProperty, ue = function() {
    var l = /[^.]+$/.exec(oe && oe.keys && oe.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), me = H.toString, ye = $.call(Object), pt = RegExp(
    "^" + $.call(V).replace(re, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Rt = Nt ? we.Buffer : void 0, zr = we.Symbol, Xr = we.Uint8Array;
  Rt && Rt.allocUnsafe;
  var Kr = O(Object.getPrototypeOf, Object), Zr = Object.create, eo = H.propertyIsEnumerable, to = R.splice, We = zr ? zr.toStringTag : void 0, Dt = function() {
    try {
      var l = ur(Object, "defineProperty");
      return l({}, "", {}), l;
    } catch {
    }
  }(), ro = Rt ? Rt.isBuffer : void 0, Yr = Math.max, no = Date.now, qr = ur(we, "Map"), bt = ur(Object, "create"), ao = /* @__PURE__ */ function() {
    function l() {
    }
    return function(u) {
      if (!Ge(u))
        return {};
      if (Zr)
        return Zr(u);
      l.prototype = u;
      var m = new l();
      return l.prototype = void 0, m;
    };
  }();
  function je(l) {
    var u = -1, m = l == null ? 0 : l.length;
    for (this.clear(); ++u < m; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function oo() {
    this.__data__ = bt ? bt(null) : {}, this.size = 0;
  }
  function io(l) {
    var u = this.has(l) && delete this.__data__[l];
    return this.size -= u ? 1 : 0, u;
  }
  function lo(l) {
    var u = this.__data__;
    if (bt) {
      var m = u[l];
      return m === n ? void 0 : m;
    }
    return V.call(u, l) ? u[l] : void 0;
  }
  function co(l) {
    var u = this.__data__;
    return bt ? u[l] !== void 0 : V.call(u, l);
  }
  function so(l, u) {
    var m = this.__data__;
    return this.size += this.has(l) ? 0 : 1, m[l] = bt && u === void 0 ? n : u, this;
  }
  je.prototype.clear = oo, je.prototype.delete = io, je.prototype.get = lo, je.prototype.has = co, je.prototype.set = so;
  function Re(l) {
    var u = -1, m = l == null ? 0 : l.length;
    for (this.clear(); ++u < m; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function uo() {
    this.__data__ = [], this.size = 0;
  }
  function fo(l) {
    var u = this.__data__, m = Tt(u, l);
    if (m < 0)
      return !1;
    var A = u.length - 1;
    return m == A ? u.pop() : to.call(u, m, 1), --this.size, !0;
  }
  function ho(l) {
    var u = this.__data__, m = Tt(u, l);
    return m < 0 ? void 0 : u[m][1];
  }
  function mo(l) {
    return Tt(this.__data__, l) > -1;
  }
  function vo(l, u) {
    var m = this.__data__, A = Tt(m, l);
    return A < 0 ? (++this.size, m.push([l, u])) : m[A][1] = u, this;
  }
  Re.prototype.clear = uo, Re.prototype.delete = fo, Re.prototype.get = ho, Re.prototype.has = mo, Re.prototype.set = vo;
  function tt(l) {
    var u = -1, m = l == null ? 0 : l.length;
    for (this.clear(); ++u < m; ) {
      var A = l[u];
      this.set(A[0], A[1]);
    }
  }
  function go() {
    this.size = 0, this.__data__ = {
      hash: new je(),
      map: new (qr || Re)(),
      string: new je()
    };
  }
  function po(l) {
    var u = It(this, l).delete(l);
    return this.size -= u ? 1 : 0, u;
  }
  function bo(l) {
    return It(this, l).get(l);
  }
  function xo(l) {
    return It(this, l).has(l);
  }
  function wo(l, u) {
    var m = It(this, l), A = m.size;
    return m.set(l, u), this.size += m.size == A ? 0 : 1, this;
  }
  tt.prototype.clear = go, tt.prototype.delete = po, tt.prototype.get = bo, tt.prototype.has = xo, tt.prototype.set = wo;
  function rt(l) {
    var u = this.__data__ = new Re(l);
    this.size = u.size;
  }
  function yo() {
    this.__data__ = new Re(), this.size = 0;
  }
  function So(l) {
    var u = this.__data__, m = u.delete(l);
    return this.size = u.size, m;
  }
  function Co(l) {
    return this.__data__.get(l);
  }
  function Eo(l) {
    return this.__data__.has(l);
  }
  function No(l, u) {
    var m = this.__data__;
    if (m instanceof Re) {
      var A = m.__data__;
      if (!qr || A.length < r - 1)
        return A.push([l, u]), this.size = ++m.size, this;
      m = this.__data__ = new tt(A);
    }
    return m.set(l, u), this.size = m.size, this;
  }
  rt.prototype.clear = yo, rt.prototype.delete = So, rt.prototype.get = Co, rt.prototype.has = Eo, rt.prototype.set = No;
  function _o(l, u) {
    var m = hr(l), A = !m && fr(l), U = !m && !A && rn(l), z = !m && !A && !U && an(l), Z = m || A || U || z, G = Z ? ir(l.length, String) : [], Y = G.length;
    for (var ve in l)
      Z && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ve == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      U && (ve == "offset" || ve == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      z && (ve == "buffer" || ve == "byteLength" || ve == "byteOffset") || // Skip index properties.
      en(ve, Y)) || G.push(ve);
    return G;
  }
  function cr(l, u, m) {
    (m !== void 0 && !Pt(l[u], m) || m === void 0 && !(u in l)) && sr(l, u, m);
  }
  function Oo(l, u, m) {
    var A = l[u];
    (!(V.call(l, u) && Pt(A, m)) || m === void 0 && !(u in l)) && sr(l, u, m);
  }
  function Tt(l, u) {
    for (var m = l.length; m--; )
      if (Pt(l[m][0], u))
        return m;
    return -1;
  }
  function sr(l, u, m) {
    u == "__proto__" && Dt ? Dt(l, u, {
      configurable: !0,
      enumerable: !0,
      value: m,
      writable: !0
    }) : l[u] = m;
  }
  var Ao = Wo();
  function Lt(l) {
    return l == null ? l === void 0 ? _ : E : We && We in Object(l) ? jo(l) : Ko(l);
  }
  function Qr(l) {
    return xt(l) && Lt(l) == s;
  }
  function Ro(l) {
    if (!Ge(l) || zo(l))
      return !1;
    var u = vr(l) ? pt : Q;
    return u.test(Qo(l));
  }
  function Do(l) {
    return xt(l) && nn(l.length) && !!j[Lt(l)];
  }
  function To(l) {
    if (!Ge(l))
      return Xo(l);
    var u = tn(l), m = [];
    for (var A in l)
      A == "constructor" && (u || !V.call(l, A)) || m.push(A);
    return m;
  }
  function Jr(l, u, m, A, U) {
    l !== u && Ao(u, function(z, Z) {
      if (U || (U = new rt()), Ge(z))
        Lo(l, u, Z, m, Jr, A, U);
      else {
        var G = A ? A(dr(l, Z), z, Z + "", l, u, U) : void 0;
        G === void 0 && (G = z), cr(l, Z, G);
      }
    }, on);
  }
  function Lo(l, u, m, A, U, z, Z) {
    var G = dr(l, m), Y = dr(u, m), ve = Z.get(Y);
    if (ve) {
      cr(l, m, ve);
      return;
    }
    var se = z ? z(G, Y, m + "", l, u, Z) : void 0, wt = se === void 0;
    if (wt) {
      var gr = hr(Y), pr = !gr && rn(Y), cn = !gr && !pr && an(Y);
      se = Y, gr || pr || cn ? hr(G) ? se = G : Jo(G) ? se = Fo(G) : pr ? (wt = !1, se = ko(Y)) : cn ? (wt = !1, se = Bo(Y)) : se = [] : ei(Y) || fr(Y) ? (se = G, fr(G) ? se = ti(G) : (!Ge(G) || vr(G)) && (se = Go(Y))) : wt = !1;
    }
    wt && (Z.set(Y, se), U(se, Y, A, z, Z), Z.delete(Y)), cr(l, m, se);
  }
  function Io(l, u) {
    return Yo(Zo(l, u, ln), l + "");
  }
  var Po = Dt ? function(l, u) {
    return Dt(l, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ni(u),
      writable: !0
    });
  } : ln;
  function ko(l, u) {
    return l.slice();
  }
  function Mo(l) {
    var u = new l.constructor(l.byteLength);
    return new Xr(u).set(new Xr(l)), u;
  }
  function Bo(l, u) {
    var m = Mo(l.buffer);
    return new l.constructor(m, l.byteOffset, l.length);
  }
  function Fo(l, u) {
    var m = -1, A = l.length;
    for (u || (u = Array(A)); ++m < A; )
      u[m] = l[m];
    return u;
  }
  function Vo(l, u, m, A) {
    var U = !m;
    m || (m = {});
    for (var z = -1, Z = u.length; ++z < Z; ) {
      var G = u[z], Y = void 0;
      Y === void 0 && (Y = l[G]), U ? sr(m, G, Y) : Oo(m, G, Y);
    }
    return m;
  }
  function Uo(l) {
    return Io(function(u, m) {
      var A = -1, U = m.length, z = U > 1 ? m[U - 1] : void 0, Z = U > 2 ? m[2] : void 0;
      for (z = l.length > 3 && typeof z == "function" ? (U--, z) : void 0, Z && Ho(m[0], m[1], Z) && (z = U < 3 ? void 0 : z, U = 1), u = Object(u); ++A < U; ) {
        var G = m[A];
        G && l(u, G, A, z);
      }
      return u;
    });
  }
  function Wo(l) {
    return function(u, m, A) {
      for (var U = -1, z = Object(u), Z = A(u), G = Z.length; G--; ) {
        var Y = Z[++U];
        if (m(z[Y], Y, z) === !1)
          break;
      }
      return u;
    };
  }
  function It(l, u) {
    var m = l.__data__;
    return $o(u) ? m[typeof u == "string" ? "string" : "hash"] : m.map;
  }
  function ur(l, u) {
    var m = lr(l, u);
    return Ro(m) ? m : void 0;
  }
  function jo(l) {
    var u = V.call(l, We), m = l[We];
    try {
      l[We] = void 0;
      var A = !0;
    } catch {
    }
    var U = me.call(l);
    return A && (u ? l[We] = m : delete l[We]), U;
  }
  function Go(l) {
    return typeof l.constructor == "function" && !tn(l) ? ao(Kr(l)) : {};
  }
  function en(l, u) {
    var m = typeof l;
    return u = u ?? c, !!u && (m == "number" || m != "symbol" && ne.test(l)) && l > -1 && l % 1 == 0 && l < u;
  }
  function Ho(l, u, m) {
    if (!Ge(m))
      return !1;
    var A = typeof u;
    return (A == "number" ? mr(m) && en(u, m.length) : A == "string" && u in m) ? Pt(m[u], l) : !1;
  }
  function $o(l) {
    var u = typeof l;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? l !== "__proto__" : l === null;
  }
  function zo(l) {
    return !!ue && ue in l;
  }
  function tn(l) {
    var u = l && l.constructor, m = typeof u == "function" && u.prototype || H;
    return l === m;
  }
  function Xo(l) {
    var u = [];
    if (l != null)
      for (var m in Object(l))
        u.push(m);
    return u;
  }
  function Ko(l) {
    return me.call(l);
  }
  function Zo(l, u, m) {
    return u = Yr(u === void 0 ? l.length - 1 : u, 0), function() {
      for (var A = arguments, U = -1, z = Yr(A.length - u, 0), Z = Array(z); ++U < z; )
        Z[U] = A[u + U];
      U = -1;
      for (var G = Array(u + 1); ++U < u; )
        G[U] = A[U];
      return G[u] = m(Z), or(l, this, G);
    };
  }
  function dr(l, u) {
    if (!(u === "constructor" && typeof l[u] == "function") && u != "__proto__")
      return l[u];
  }
  var Yo = qo(Po);
  function qo(l) {
    var u = 0, m = 0;
    return function() {
      var A = no(), U = i - (A - m);
      if (m = A, U > 0) {
        if (++u >= a)
          return arguments[0];
      } else
        u = 0;
      return l.apply(void 0, arguments);
    };
  }
  function Qo(l) {
    if (l != null) {
      try {
        return $.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Pt(l, u) {
    return l === u || l !== l && u !== u;
  }
  var fr = Qr(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Qr : function(l) {
    return xt(l) && V.call(l, "callee") && !eo.call(l, "callee");
  }, hr = Array.isArray;
  function mr(l) {
    return l != null && nn(l.length) && !vr(l);
  }
  function Jo(l) {
    return xt(l) && mr(l);
  }
  var rn = ro || ai;
  function vr(l) {
    if (!Ge(l))
      return !1;
    var u = Lt(l);
    return u == w || u == y || u == f || u == N;
  }
  function nn(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function Ge(l) {
    var u = typeof l;
    return l != null && (u == "object" || u == "function");
  }
  function xt(l) {
    return l != null && typeof l == "object";
  }
  function ei(l) {
    if (!xt(l) || Lt(l) != D)
      return !1;
    var u = Kr(l);
    if (u === null)
      return !0;
    var m = V.call(u, "constructor") && u.constructor;
    return typeof m == "function" && m instanceof m && $.call(m) == ye;
  }
  var an = Ot ? At(Ot) : Do;
  function ti(l) {
    return Vo(l, on(l));
  }
  function on(l) {
    return mr(l) ? _o(l) : To(l);
  }
  var ri = Uo(function(l, u, m) {
    Jr(l, u, m);
  });
  function ni(l) {
    return function() {
      return l;
    };
  }
  function ln(l) {
    return l;
  }
  function ai() {
    return !1;
  }
  e.exports = ri;
})(Zt, Zt.exports);
var ki = Zt.exports;
const Wn = /* @__PURE__ */ Pr(ki), Mi = {
  [De.Sm]: 768,
  [De.Md]: 1024,
  [De.Lg]: 1400,
  [De.Xl]: 1920
}, sn = kn(Mi), od = Wn({}, Un, {
  theme: {
    screens: sn,
    container: {
      center: !0,
      screens: sn,
      padding: {
        DEFAULT: J(20),
        md: J(48),
        lg: J(120),
        xl: J(240)
      }
    }
  }
}), Bi = {
  default: 0
}, Fi = kn(Bi), id = Wn({}, Un, {
  theme: {
    screens: Fi
  },
  corePlugins: {
    container: !1
  }
});
var jn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", c = 0; c < arguments.length; c++) {
        var s = arguments[c];
        s && (i = a(i, n(s)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var c = "";
      for (var s in i)
        t.call(i, s) && i[s] && (c = a(c, s));
      return c;
    }
    function a(i, c) {
      return c ? i ? i + " " + c : i + c : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(jn);
var Vi = jn.exports;
const b = /* @__PURE__ */ Pr(Vi);
var te = /* @__PURE__ */ ((e) => (e.Neutral = "neutral", e.PrimarySolid = "primary-solid", e.PrimarySoft = "primary-soft", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(te || {});
const Ui = {
  [te.PrimarySolid]: "badge-bg-color-primary",
  [te.Neutral]: "badge-bg-color-neutral",
  [te.PrimarySoft]: "badge-bg-color-primary-soft",
  [te.Success]: "bg-success-surface",
  [te.Warning]: "bg-warning-surface",
  [te.Error]: "bg-error-surface"
}, Wi = {
  [te.PrimarySolid]: "badge-text-color-primary",
  [te.Neutral]: "badge-text-color-neutral",
  [te.PrimarySoft]: "badge-text-color-primary-soft",
  [te.Success]: "text-on-success",
  [te.Warning]: "text-on-warning",
  [te.Error]: "text-on-error"
}, ji = {
  [te.PrimarySolid]: "badge-border-color-primary",
  [te.Neutral]: "badge-border-color-neutral",
  [te.PrimarySoft]: "badge-border-color-soft",
  [te.Success]: "border-success-surface",
  [te.Warning]: "border-warning-surface",
  [te.Error]: "border-error-surface"
}, Gi = "text-label-md";
function Yt({ type: e, label: t }) {
  const r = Ui[e], n = Wi[e], a = ji[e];
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "inline-flex items-center space-x-2 rounded-full border disabled:opacity-30",
        r,
        a,
        t ? "px-xs py-xxs" : "h-1.5 w-1.5"
      ),
      children: /* @__PURE__ */ o("span", { className: b(Gi, n), children: t })
    }
  );
}
var ie = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(ie || {}), W = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Ghost = "ghost", e.Outlined = "outlined", e.Destructive = "destructive", e))(W || {}), er = /* @__PURE__ */ ((e) => (e.Button = "button", e.Submit = "submit", e.Reset = "reset", e))(er || {});
const Hi = {
  [ie.Small]: "px-md py-xs",
  [ie.Medium]: "px-md py-sm"
}, $i = {
  [ie.Small]: "p-xs",
  [ie.Medium]: "p-sm"
}, zi = {
  [W.Primary]: "button-bg-color-primary",
  [W.Secondary]: "button-bg-color-secondary",
  [W.Ghost]: "bg-transparent",
  [W.Outlined]: "button-outline-bg-color",
  [W.Destructive]: "button-bg-color-error"
}, Xi = {
  [W.Primary]: "button-bg-color-disabled-primary",
  [W.Secondary]: "button-bg-color-secondary",
  [W.Ghost]: "bg-transparent",
  [W.Outlined]: "button-outline-bg-color",
  [W.Destructive]: "button-bg-color-error"
}, ze = "button-text-color-neutral", Ki = {
  [W.Primary]: "button-text-color-primary",
  [W.Secondary]: ze,
  [W.Ghost]: ze,
  [W.Outlined]: ze,
  [W.Destructive]: "button-text-color-error"
}, Zi = {
  [ie.Small]: "text-label-md",
  [ie.Medium]: "text-label-lg"
}, Yi = {
  [W.Primary]: ze,
  [W.Secondary]: ze,
  [W.Ghost]: ze,
  [W.Outlined]: ze,
  [W.Destructive]: "button-text-color-error"
};
function ge({
  icon: e,
  text: t,
  disabled: r,
  onClick: n,
  fullWidth: a,
  htmlType: i = er.Button,
  size: c = ie.Medium,
  type: s = W.Primary,
  iconAfterText: d = !1,
  tabIndex: f = 0,
  testId: g
}) {
  const h = s === W.Outlined, x = e && !t ? $i[c] : Hi[c], w = Zi[c], y = r ? Xi[s] : zi[s], p = r ? Yi[s] : Ki[s], E = /* @__PURE__ */ C(
    "button",
    {
      onClick: n,
      type: i,
      className: b(
        "state-layer relative flex items-center justify-center gap-2 rounded-full transition-all duration-150 ease-in",
        h ? "disabled:cursor-not-allowed" : "disabled:opacity-40 disabled:cursor-not-allowed",
        x,
        y,
        a && "w-full",
        d ? "flex-row-reverse" : "flex-row"
      ),
      disabled: r,
      tabIndex: f,
      "data-testid": g,
      children: [
        e && /* @__PURE__ */ o("span", { className: b(p), children: e }),
        t && /* @__PURE__ */ o("span", { className: b("font-inter", p, w), children: t })
      ]
    }
  );
  return h ? /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "button-border-color-outline inline-flex rounded-full p-[1px]",
        a && "w-full",
        r && "opacity-40"
      ),
      children: E
    }
  ) : E;
}
function ld({
  htmlType: e = er.Button,
  children: t,
  tabIndex: r = 0,
  ...n
}) {
  return /* @__PURE__ */ o(
    "button",
    {
      className: "button-pill-border-color button-pill-text-color flex items-center justify-center rounded-xl border px-sm text-body-md disabled:opacity-40",
      type: e,
      tabIndex: r,
      ...n,
      children: t
    }
  );
}
function ce({
  htmlType: e = er.Button,
  children: t,
  className: r,
  tabIndex: n = 0,
  testId: a,
  ...i
}) {
  return /* @__PURE__ */ o(
    "button",
    {
      type: e,
      ...i,
      className: b("appearance-none", r),
      tabIndex: n,
      "data-testid": a,
      children: t
    }
  );
}
function Gn(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M4 12.004a1 1 0 0 0 .293.703l6 6a1 1 0 0 0 1.414-1.414L7.414 13H19a1 1 0 1 0 0-2H7.414l4.293-4.293a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 0 0-.293.705z"
        }
      )
    }
  );
}
function qi(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M11.45 15.335a1 1 0 0 0 1.257-.128l5-5a1 1 0 0 0-1.414-1.414L12 13.086 7.707 8.793a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 .157.128"
        }
      )
    }
  );
}
function Qi(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M8.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
        }
      )
    }
  );
}
function kr(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "m10.707 6.293 5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 1.414-1.414"
        }
      )
    }
  );
}
function Ji(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M17.483 6.29a1 1 0 0 0-.705-.29h-8.07a1 1 0 1 0 0 2h5.656l-8.071 8.071a1 1 0 1 0 1.414 1.414l8.071-8.07v5.656a1 1 0 1 0 2 0v-8.07a1 1 0 0 0-.291-.706l-.002-.002z"
        }
      )
    }
  );
}
function el(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m10.26 13.845 5.95-5.95a.994.994 0 0 1 1.405-.008.994.994 0 0 1-.008 1.406L10.95 15.95a.994.994 0 0 1-1.406.008l-2.846-2.845a.994.994 0 0 1 .01-1.406.994.994 0 0 1 1.405-.009z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function tl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.21-14.104-5.95 5.95-2.147-2.148a.994.994 0 0 0-1.406.009.994.994 0 0 0-.009 1.405l2.846 2.846a.994.994 0 0 0 1.406-.008l6.657-6.657a.994.994 0 0 0 .008-1.406.994.994 0 0 0-1.405.009",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Et(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.415L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.294a1 1 0 0 0 1.414-1.415L13.414 12z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function Mr(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-1H6a3 3 0 0 1-3-3zm6 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1zm6-11h-5a3 3 0 0 0-3 3v5H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function rl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o("rect", { width: 10, height: 2, x: 7, y: 11, fill: "currentColor", rx: 1 })
    }
  );
}
function nl(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M11.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M5.165 11.45a1 1 0 0 0 .128 1.257l5 5a1 1 0 0 0 1.414-1.414L7.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0-.128.157"
          }
        )
      ]
    }
  );
}
function al(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M11.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L9.586 12 5.293 7.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M17.835 11.45a1 1 0 0 1-.128 1.257l-5 5a1 1 0 0 1-1.414-1.414L15.586 12l-4.293-4.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 .128.157"
          }
        )
      ]
    }
  );
}
function tr(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-14.4A1.2 1.2 0 1 0 12 9a1.2 1.2 0 0 0 0-2.4m1.2 9a1.2 1.2 0 0 1-2.4 0V12a1.2 1.2 0 0 1 2.4 0z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ol(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M18.27 2.259c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.259S16.302 1 17.002 1s1.268.564 1.268 1.259m1.425 17.785c0 .695-.568 1.259-1.268 1.259s-1.267-.564-1.267-1.26c0-.695.567-1.258 1.267-1.258s1.268.563 1.268 1.259m-2.33-13.379a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.057A1.06 1.06 0 0 0 16.3 5.61a1.06 1.06 0 0 0 1.064 1.056Zm3.891-.651a1.06 1.06 0 0 1-1.063 1.056 1.06 1.06 0 0 1-1.064-1.056 1.06 1.06 0 0 1 1.064-1.057 1.06 1.06 0 0 1 1.063 1.057m-4.253 3.329c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.734-.52c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9m1.357 1.777c.5 0 .906-.402.906-.899s-.405-.9-.906-.9c-.5 0-.905.403-.905.9s.405.9.905.9Zm-2.309.495a.79.79 0 0 1-.792.787.79.79 0 0 1-.791-.787c0-.434.354-.786.791-.786s.792.352.792.786m-3.62.404a.79.79 0 0 0 .792-.787.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .435.354.787.791.787m5.907.471a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.786.79.79 0 0 1 .792-.787.79.79 0 0 1 .791.787Zm-4.21 1.554c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.968.178a.68.68 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675m-5.774-.582c.375 0 .68-.302.68-.675a.68.68 0 0 0-.68-.675.68.68 0 0 0-.68.675c0 .373.304.675.68.675m2.127.943c0 .31-.254.561-.566.561a.564.564 0 0 1-.566-.562c0-.31.253-.561.566-.561s.566.251.566.562m.407 2.114a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.791-.09a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m-1.472-.765a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m-.973-1.64c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.251.566.562m-.588-3.666a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.562.564.564 0 0 0-.565.562c0 .31.253.562.565.562m.745-2.473a.496.496 0 0 1-.497.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494Zm.047-1.123a.406.406 0 0 0 .407-.406.406.406 0 0 0-.407-.405.407.407 0 0 0-.408.405c0 .224.182.406.408.406m-.452-1.26a.496.496 0 0 1-.498.494.496.496 0 0 1-.498-.494c0-.273.223-.494.498-.494s.498.22.498.494m4.776 10.32a.564.564 0 0 0 .566-.561.564.564 0 0 0-.566-.562.564.564 0 0 0-.566.562c0 .31.253.562.566.562ZM12.883 4.439c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.254-.562.566-.562s.566.251.566.562m-.18 2.945a.564.564 0 0 0 .566-.562.564.564 0 0 0-.566-.561.564.564 0 0 0-.566.561c0 .31.253.562.566.562m.045 1.597a.677.677 0 0 1-.68.676.68.68 0 0 1-.679-.676c0-.373.304-.675.68-.675.375 0 .68.302.68.675Zm-2.74.676a.79.79 0 0 0 .791-.786.79.79 0 0 0-.791-.787.79.79 0 0 0-.792.787c0 .434.354.786.792.786m-1.494-.36c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.406-.9.906-.9s.905.403.905.9m-3.529 2.18a1.06 1.06 0 0 0 1.063-1.056 1.06 1.06 0 0 0-1.063-1.056A1.06 1.06 0 0 0 3.92 10.42a1.06 1.06 0 0 0 1.064 1.056Zm-1.45.9c0 .696-.568 1.26-1.268 1.26S1 13.073 1 12.377c0-.695.567-1.259 1.267-1.259s1.268.564 1.268 1.26Zm.386-3.531A1.06 1.06 0 0 0 4.985 7.79 1.06 1.06 0 0 0 3.92 6.733 1.06 1.06 0 0 0 2.858 7.79 1.06 1.06 0 0 0 3.92 8.846Zm3.53-2.181c0 .497-.405.9-.906.9a.903.903 0 0 1-.905-.9c0-.496.405-.9.905-.9s.906.404.906.9M6.162 5.182c.5 0 .905-.403.905-.9 0-.496-.405-.9-.905-.9s-.906.404-.906.9c0 .497.406.9.906.9m3.19-1.326a.79.79 0 0 1-.791.787.79.79 0 0 1-.792-.787c0-.434.354-.786.792-.786.437 0 .791.352.791.786m1.268.788c.375 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.68.68 0 0 0-.68.675c0 .373.304.676.68.676m1.063 1.708a.68.68 0 0 1-.68.675.677.677 0 0 1-.68-.675c0-.373.305-.675.68-.675s.68.302.68.675m-2.739.695a.79.79 0 0 0 .792-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.791.786m-1.832 5.578a.407.407 0 0 1-.408.405.407.407 0 0 1-.408-.405c0-.223.182-.405.408-.405s.408.181.408.405m1.221.201a.496.496 0 0 0 .497-.494.496.496 0 0 0-.497-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m2.354-1.236c0 .31-.253.562-.565.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.565.252.565.562m-.135 2.361c.375 0 .68-.302.68-.675a.677.677 0 0 0-.68-.675.677.677 0 0 0-.68.675c0 .373.304.675.68.675m-1.608-.135c0 .31-.253.562-.566.562a.564.564 0 0 1-.565-.562c0-.31.253-.562.565-.562.313 0 .566.252.566.562m-2.488.538a.496.496 0 0 0 .498-.494.496.496 0 0 0-.498-.495.496.496 0 0 0-.498.495c0 .273.223.494.498.494m.588.991c0 .31-.254.562-.566.562a.564.564 0 0 1-.566-.562c0-.31.253-.562.566-.562s.566.252.566.562m1.742.855c.376 0 .68-.303.68-.675a.677.677 0 0 0-.68-.676.677.677 0 0 0-.68.675c0 .373.305.676.68.676m3.484-1.08a.79.79 0 0 1-.79.786.79.79 0 0 1-.792-.786c0-.435.354-.787.791-.787s.792.352.792.787Zm.794 2.743c.5 0 .906-.402.906-.9 0-.496-.406-.899-.906-.899s-.905.403-.905.9.405.9.905.9Zm-2.536-.518a.79.79 0 0 1-.792.786.79.79 0 0 1-.792-.787.79.79 0 0 1 .792-.786.79.79 0 0 1 .792.787m-2.669 2.316a.79.79 0 0 0 .791-.786.79.79 0 0 0-.792-.786.79.79 0 0 0-.791.786c0 .434.354.786.792.786m2.466 1.079c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.496.405-.9.906-.9.5 0 .905.404.905.9M13.584 22a1.06 1.06 0 0 0 1.064-1.056 1.06 1.06 0 0 0-1.064-1.057 1.06 1.06 0 0 0-1.063 1.057A1.06 1.06 0 0 0 13.584 22m-1.379-2.788c0 .497-.405.9-.905.9a.903.903 0 0 1-.906-.9c0-.497.405-.9.905-.9s.906.403.906.9m3.123.54a1.06 1.06 0 0 0 1.063-1.057 1.06 1.06 0 0 0-1.063-1.056 1.06 1.06 0 0 0-1.064 1.056 1.06 1.06 0 0 0 1.064 1.057m-7.741-2.699a.677.677 0 0 1-.68.676.677.677 0 0 1-.68-.676c0-.373.305-.675.68-.675s.68.302.68.675"
        }
      )
    }
  );
}
function Hn(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.533 9.321A7 7 0 1 0 19 12a1 1 0 1 1 2 0 9 9 0 1 1-9-9 1 1 0 1 1 0 2 7 7 0 0 0-6.467 4.321",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function il(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 11V8.104C8 6.176 9.577 5 11.5 5s3.482 1.176 3.482 3.104L15 11h2.018L17 8.104C17 5.285 14.31 3 11.5 3S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.817-2.15-2-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function ll(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 11V8.104C8 6.5 9.577 5 11.5 5S15 6.5 15 8h2c0-2.82-2.69-5-5.5-5S6 5.285 6 8.104V11c-1.183 0-2 .962-2 2.15v5.7C4 20.039 4.96 21 6.143 21h10.714A2.146 2.146 0 0 0 19 18.85v-5.7c0-1.188-.96-2.15-2.143-2.15zm5.321 5.272c0 .95-.767 1.72-1.714 1.72s-1.714-.77-1.714-1.72.767-1.72 1.714-1.72 1.714.77 1.714 1.72",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function cl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M21 9a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h16a1 1 0 0 1 1 1m0 6a1 1 0 0 1-1 1H10a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1"
        }
      )
    }
  );
}
function $n(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
        }
      )
    }
  );
}
function sl(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 8a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v8a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6zm2 0a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3.871a19.13 19.13 0 0 1-16 0zm0 6.051V16a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1.949a21.13 21.13 0 0 1-16 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function zn(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
        }
      )
    }
  );
}
function ul(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
          }
        ),
        /* @__PURE__ */ o("path", { fill: "currentColor", d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" })
      ]
    }
  );
}
function dl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 4a7 7 0 1 0 3.594 13.008l3.699 3.7a1 1 0 0 0 1.414-1.415l-3.555-3.555A7 7 0 0 0 11 4m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function fl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M12 6a1 1 0 0 0-1 1v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L13 16.586V7a1 1 0 0 0-1-1"
        }
      )
    }
  );
}
function un(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M11.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 7.414V17a1 1 0 1 1-2 0V7.414L8.707 9.707a1 1 0 0 1-1.414-1.414z"
        }
      )
    }
  );
}
function hl(e) {
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M17.35 9c.578 0 .867.681.459 1.08l-4.85 4.735a.66.66 0 0 1-.917 0l-4.85-4.735C6.781 9.68 7.071 9 7.648 9z"
        }
      )
    }
  );
}
function Xn(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18.72 6.695a1 1 0 1 0-1.44-1.39l-1.518 1.572C14.601 6.348 13.331 6 12 6 8.739 6 5.843 8.092 4.017 9.805c-1.29 1.212-1.29 3.178 0 4.39a18 18 0 0 0 2.666 2.083l-1.695 1.755a1 1 0 0 0 1.438 1.39zM8.67 14.219l5.431-5.623a4 4 0 0 0-5.43 5.623Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M16 12a4 4 0 0 1-3.975 4l-1.749 1.81c.56.122 1.136.19 1.724.19 3.26 0 6.157-2.092 7.983-3.805 1.29-1.212 1.29-3.178 0-4.39a20 20 0 0 0-1.071-.936l-2.914 3.017z"
          }
        )
      ]
    }
  );
}
function Kn(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ o("path", { fill: "currentColor", d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19.983 9.805c1.29 1.212 1.29 3.178 0 4.39C18.157 15.908 15.26 18 12 18c-3.261 0-6.157-2.092-7.983-3.805-1.29-1.212-1.29-3.178 0-4.39C5.843 8.092 8.74 6 12 6s6.157 2.092 7.983 3.805M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function cd({
  label: e,
  isChecked: t,
  isDisabled: r,
  onChange: n
}) {
  const a = t ? ul : zn;
  return /* @__PURE__ */ C(
    "label",
    {
      className: b("flex flex-row gap-x-1 text-center has-[:disabled]:opacity-40", {
        disabled: r,
        "cursor-pointer": !r
      }),
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: b("relative flex h-10 w-10 items-center justify-center rounded-full", {
              "state-layer": !r
            }),
            children: [
              /* @__PURE__ */ o(
                "input",
                {
                  type: "radio",
                  checked: t,
                  onChange: n,
                  disabled: r,
                  className: b("peer appearance-none")
                }
              ),
              /* @__PURE__ */ o("span", { className: "radio-icon-color peer-checked:radio-icon-checked-color peer-checked:peer-disabled:radio-icon-checked-disabled-color absolute [&_svg]:h-6 [&_svg]:w-6", children: /* @__PURE__ */ o(a, {}) })
            ]
          }
        ),
        /* @__PURE__ */ o("span", { className: "radio-label-color inline-flex items-center justify-center text-label-lg ", children: e })
      ]
    }
  );
}
const ml = "bg-transparent", vl = "button-segment-bg-color-selected", gl = "button-segment-text-color-default", pl = "button-segment-text-color-hover", bl = "button-segment-text-color-focused", xl = `${gl} ${pl} ${bl}`, wl = "button-segment-text-color-selected", yl = `
  button-segment-underline-base
  before:bottom-0
  button-segment-underline-hover
  button-segment-underline-hover-color
`, Sl = `
  button-segment-underline-base
  button-segment-underline-selected
`;
var st = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.Underlined = "underlined", e))(st || {});
function sd({
  icon: e,
  label: t,
  selected: r,
  disabled: n,
  onClick: a,
  type: i = st.Rounded,
  isNested: c = !1
}) {
  const s = i === st.Underlined, d = r ? s ? "bg-transparent" : vl : ml, f = s ? r ? Sl : yl : "", g = r ? wl : xl, h = s ? c ? "px-md py-sm" : "px-lg py-md" : "px-sm py-[6px]", x = s ? "" : "rounded-full", w = c ? s ? "text-title-sm" : "text-label-md" : s ? "text-title-md" : "text-label-lg";
  return /* @__PURE__ */ o(
    ce,
    {
      onClick: a,
      className: b(
        "enabled:state-layer relative flex items-center disabled:opacity-40",
        d,
        g,
        h,
        x,
        f,
        {
          "pl-xs": !!e && !s
        }
      ),
      disabled: n,
      children: /* @__PURE__ */ C("div", { className: b("flex flex-row items-center justify-center gap-2", w), children: [
        e && /* @__PURE__ */ o("span", { children: e }),
        /* @__PURE__ */ o("span", { className: "shrink-0 font-inter", children: t })
      ] })
    }
  );
}
const Zn = Fe(
  ({
    isChecked: e,
    isIndeterminate: t,
    label: r,
    isLabelFirst: n,
    isDisabled: a,
    onCheckedChange: i,
    name: c
  }, s) => {
    const d = le(null);
    de(() => {
      d.current && (d.current.indeterminate = t ?? !1);
    }, [t, d]);
    const f = t ? rl : el;
    function g(h) {
      s && (typeof s == "function" ? s(h) : s.current = h), d.current = h;
    }
    return /* @__PURE__ */ C(
      "div",
      {
        className: b(
          "group inline-flex has-[:disabled]:opacity-40",
          n ? "flex-row-reverse" : "flex-row",
          {
            disabled: a,
            "gap-x-2": r
          }
        ),
        children: [
          /* @__PURE__ */ o(
            "input",
            {
              id: c,
              name: c,
              type: "checkbox",
              className: "peer hidden appearance-none",
              checked: e,
              ref: g,
              disabled: a,
              onChange: (h) => {
                i == null || i(h);
              }
            }
          ),
          /* @__PURE__ */ o(
            "span",
            {
              onClick: () => {
                var h;
                return (h = d.current) == null ? void 0 : h.click();
              },
              className: b(
                "checkbox-base checkbox-state checkbox-icon checkbox-icon-hidden",
                "checkbox-border-default",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-border-checked",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-bg-checked",
                "peer-[&:is(:checked,:indeterminate)]:checkbox-text-checked",
                "peer-disabled:peer-[&:not(:checked,:indeterminate)]:checkbox-border-color-disabled",
                "peer-disabled:peer-[&:is(:checked,:indeterminate)]:checkbox-border-color-disabled-checked",
                "peer-disabled:peer-[&:is(:checked,:indeterminate)]:checkbox-bg-color-disabled-checked"
              ),
              children: /* @__PURE__ */ o(f, {})
            }
          ),
          /* @__PURE__ */ o(Cl, { label: r, name: c })
        ]
      }
    );
  }
);
function Cl({ label: e, name: t }) {
  return /* @__PURE__ */ o("label", { htmlFor: t, className: "checkbox-label checkbox-label-disabled", children: e });
}
var Xe = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(Xe || {});
const El = "divider-bg-color", Nl = {
  [Xe.Horizontal]: "w-full",
  [Xe.Vertical]: "h-full"
}, _l = "1px";
function Ol({
  type: e = Xe.Horizontal,
  width: t,
  height: r,
  lineHeight: n = _l
}) {
  const a = {
    ...e === Xe.Horizontal ? { height: n } : { width: n }
  };
  let i = Nl[e];
  return t && e === Xe.Horizontal ? i = t : r && e === Xe.Vertical && (i = r), /* @__PURE__ */ o("div", { className: b(El, i), style: a });
}
var jt = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(jt || {}), He = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Left = "left", e.Right = "right", e))(He || {});
function vt({
  text: e,
  position: t = He.Top,
  maxWidth: r = "max-w-[200px]",
  offset: n = 8,
  openDelay: a = 0,
  closeDelay: i = 100,
  children: c
}) {
  const s = le(null), d = le(null), [f, g] = he(!1), [h, x] = he({ top: 0, left: 0 }), w = le(), y = le(), p = () => {
    clearTimeout(w.current), clearTimeout(y.current);
  }, S = () => {
    p(), w.current = setTimeout(() => g(!0), a);
  }, E = () => {
    p(), y.current = setTimeout(() => g(!1), i);
  };
  return Ar(() => {
    var P;
    if (!f) return;
    const N = (P = s.current) == null ? void 0 : P.getBoundingClientRect();
    if (!N) return;
    const T = {
      [He.Top]: {
        top: N.top - n,
        left: N.left + N.width / 2,
        transform: "translate(-50%, -100%)"
      },
      [He.Bottom]: {
        top: N.bottom + n,
        left: N.left + N.width / 2,
        transform: "translate(-50%, 0)"
      },
      [He.Left]: {
        top: N.top + N.height / 2,
        left: N.left - n,
        transform: "translate(-100%, -50%)"
      },
      [He.Right]: {
        top: N.top + N.height / 2,
        left: N.right + n,
        transform: "translate(0, -50%)"
      }
    }[t];
    x({ top: T.top, left: T.left }), d.current.style.transform = T.transform;
  }, [f, t, n]), Ar(() => {
    if (!f) return;
    const N = () => {
      var P;
      const T = (P = s.current) == null ? void 0 : P.getBoundingClientRect();
      T && x((L) => ({ ...L, left: T.left + T.width / 2 }));
    };
    return window.addEventListener("scroll", N, !0), window.addEventListener("resize", N), () => {
      window.removeEventListener("scroll", N, !0), window.removeEventListener("resize", N);
    };
  }, [f]), /* @__PURE__ */ C(Ze, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        ref: s,
        className: "inline-block cursor-pointer",
        onMouseEnter: S,
        onFocus: S,
        onMouseLeave: E,
        onBlur: E,
        children: c
      }
    ),
    f && di(
      /* @__PURE__ */ o(
        "div",
        {
          ref: d,
          role: "tooltip",
          style: {
            position: "fixed",
            top: h.top,
            left: h.left,
            transition: "opacity .15s ease",
            opacity: 1
          },
          className: b("z-[9999999999] w-max rounded p-xs tooltip-bg tooltip-text-color", r),
          onMouseEnter: S,
          onMouseLeave: E,
          children: /* @__PURE__ */ o("p", { className: "w-full break-words", children: e })
        }
      ),
      document.body
    )
  ] });
}
function ud({
  keyText: e,
  value: t,
  tooltipPosition: r,
  tooltipText: n,
  supportingLabel: a,
  size: i = jt.Small,
  isTruncated: c = !1,
  copyText: s,
  onCopySuccess: d,
  onCopyError: f,
  fullwidth: g,
  isReverse: h = !1,
  valueHoverTitle: x
}) {
  const w = h ? "flex-row-reverse" : "flex-row";
  async function y(p) {
    if (navigator.clipboard && s)
      try {
        await navigator.clipboard.writeText(s), d == null || d(p, s);
      } catch (S) {
        console.error("Failed to copy:", S), f == null || f(S, s);
      }
  }
  return /* @__PURE__ */ C(
    "div",
    {
      className: b(
        "flex w-full items-baseline gap-xs py-xxs font-inter",
        w,
        {
          "justify-between": g
        }
      ),
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: b("flex shrink-0 flex-row items-center gap-x-0.5", {
              "w-1/4": !g
            }),
            children: [
              /* @__PURE__ */ o("span", { className: "key-value-key-text-color text-body-md", children: e }),
              n && /* @__PURE__ */ o(vt, { text: n, position: r, children: /* @__PURE__ */ o(tr, { className: "key-supporting-text-color" }) })
            ]
          }
        ),
        /* @__PURE__ */ C(
          "div",
          {
            className: b("flex flex-row items-baseline gap-1 break-all", {
              "w-3/4": !g,
              truncate: c
            }),
            children: [
              /* @__PURE__ */ o(
                "span",
                {
                  title: x,
                  className: b(
                    "key-value-hover-text-color",
                    i === jt.Medium ? "text-body-lg" : "text-body-md",
                    { truncate: c }
                  ),
                  children: t
                }
              ),
              a && /* @__PURE__ */ o(
                "span",
                {
                  className: b(
                    "key-supporting-text-color",
                    i === jt.Medium ? "text-body-md" : "text-body-sm"
                  ),
                  children: a
                }
              ),
              /* @__PURE__ */ o("div", { className: "self-center", children: s && /* @__PURE__ */ o(ce, { onClick: y, children: /* @__PURE__ */ o(Mr, { className: "key-supporting-text-color" }) }) })
            ]
          }
        )
      ]
    }
  );
}
var fe = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(fe || {});
const Al = {
  [fe.Small]: "text-title-sm",
  [fe.Medium]: "text-title-md",
  [fe.Large]: "text-title-lg"
}, Rl = {
  [fe.Small]: "text-label-md",
  [fe.Medium]: "text-label-md",
  [fe.Large]: "text-label-lg"
}, Dl = {
  [fe.Small]: "text-label-md",
  [fe.Medium]: "text-label-md",
  [fe.Large]: "text-label-lg"
};
function dd({
  size: e = fe.Medium,
  isCentered: t,
  supportingLabel: r,
  label: n,
  text: a,
  tooltipPosition: i,
  tooltipText: c
}) {
  const s = Al[e], d = Rl[e], f = Dl[e], g = t ? "items-center" : "items-start", h = e === fe.Small ? "gap-0.5" : "gap-1";
  return /* @__PURE__ */ C("div", { className: b("flex flex-col", g, h), children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row flex-wrap items-center gap-0.5", children: [
      /* @__PURE__ */ o("span", { className: b("label-text-primary-neutral font-inter", s), children: a }),
      r && /* @__PURE__ */ o(
        "span",
        {
          className: b(
            "label-text-secondary-neutral font-inter",
            d
          ),
          children: r
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { className: "flex flex-row items-center gap-x-0.5", children: /* @__PURE__ */ C(
      "span",
      {
        className: b(
          "label-text-secondary-neutral flex items-center font-inter",
          f
        ),
        children: [
          n,
          c && /* @__PURE__ */ o("div", { className: "ml-xxxs flex items-center", children: /* @__PURE__ */ o(vt, { text: c, position: i, children: /* @__PURE__ */ o(tr, { className: "label-text-secondary-neutral" }) }) })
        ]
      }
    ) })
  ] });
}
function Tl({
  showRightIcon: e,
  hideBottomBorder: t,
  onClick: r,
  isDisabled: n,
  children: a,
  isHighlighted: i
}) {
  function c(d) {
    (d.key === "Enter" || d.key === " ") && !n && r && r();
  }
  function s() {
    !n && r && r();
  }
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "w-full",
        {
          "list-item-border-color border-b pb-xs": !t
        },
        { "opacity-40": n }
      ),
      children: /* @__PURE__ */ C(
        "div",
        {
          onClick: s,
          role: "button",
          tabIndex: 0,
          onKeyDown: c,
          className: b(
            "list-item-color relative flex flex-row items-center justify-between px-md py-sm",
            !n && r ? "cursor-pointer" : "cursor-default",
            {
              "list-item-highlight-bg": i,
              "state-layer": !n
            }
          ),
          children: [
            a,
            e && /* @__PURE__ */ o(
              ge,
              {
                size: ie.Small,
                type: W.Ghost,
                disabled: n,
                icon: /* @__PURE__ */ o(kr, {})
              }
            )
          ]
        }
      )
    }
  );
}
function fd({
  title: e,
  titleCentered: t,
  onBack: r,
  onClose: n,
  testId: a
}) {
  const i = t ? "text-center" : r ? "ml-1" : "", c = t && (!r || !n);
  return /* @__PURE__ */ C("div", { className: "header-bg-color header-text-color flex min-h-[56px] w-full items-center px-md--rs pb-xs pt-sm [&_svg]:h-5 [&_svg]:w-5", children: [
    r ? /* @__PURE__ */ o(
      ge,
      {
        size: ie.Small,
        type: W.Ghost,
        onClick: r,
        icon: /* @__PURE__ */ o(Gn, {})
      }
    ) : c && /* @__PURE__ */ o("div", { className: "w-9" }),
    /* @__PURE__ */ o("div", { className: b("flex-grow", i), children: /* @__PURE__ */ o("span", { className: "font-inter text-title-lg", "data-testid": a, children: e }) }),
    n ? /* @__PURE__ */ o(
      ge,
      {
        size: ie.Small,
        type: W.Ghost,
        onClick: n,
        icon: /* @__PURE__ */ o(Et, {}),
        testId: "close-icon"
      }
    ) : c && /* @__PURE__ */ o("div", { className: "w-9" })
  ] });
}
function hd({
  children: e,
  hasBorder: t,
  bgColor: r = "panel-bg"
}) {
  return /* @__PURE__ */ o("div", { className: b("flex w-full flex-col rounded-xl", r, t ? "border panel-border-color" : "border border-transparent"), children: e });
}
function Ll() {
  return /* @__PURE__ */ o("div", { className: "flex h-full w-full items-center justify-center bg-iota-neutral-96 dark:bg-iota-neutral-10", children: /* @__PURE__ */ o(sl, { className: "h-4 w-4 text-iota-neutral-40 dark:text-iota-neutral-60" }) });
}
const Il = Fe(
  ({ onError: e, renderFallback: t, ...r }, n) => {
    const [a, i] = he(!1);
    function c(s) {
      i(!0), e == null || e(s);
    }
    return a || !r.src ? t || /* @__PURE__ */ o(Ll, {}) : /* @__PURE__ */ o(Yn, { onError: c, ref: n, ...r });
  }
), Yn = Fe(
  (e, t) => /* @__PURE__ */ o("img", { className: "h-full w-full object-cover", ref: t, ...e })
);
var Te = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Te || {}), Gt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Elevated = "elevated", e))(Gt || {});
const Pl = {
  [Te.Default]: "bg-default-surface text-on-default",
  [Te.Error]: "bg-error-surface text-on-error",
  [Te.Success]: "bg-success-surface text-on-success",
  [Te.Warning]: "bg-warning-surface text-on-warning"
}, kl = {
  [Te.Default]: "bg-default-surface",
  [Te.Error]: "bg-error-surface",
  [Te.Success]: "bg-success-surface",
  [Te.Warning]: "bg-warning-surface"
};
function md({
  icon: e,
  title: t,
  supportingText: r,
  type: n,
  style: a
}) {
  const i = Pl[n], c = a === Gt.Elevated ? kl[n] : "";
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("flex flex-row items-start gap-4 py-xs pr-lg", c, {
        "rounded-lg pl-xs": a === Gt.Elevated
      }),
      children: [
        e && /* @__PURE__ */ o(
          "span",
          {
            className: b(
              "flex items-center justify-center rounded-lg [&_svg]:h-4 [&_svg]:w-4",
              i,
              {
                "p-xs": a === Gt.Default
              }
            ),
            children: e
          }
        ),
        /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
          t && /* @__PURE__ */ o("span", { className: "infobox-text-title text-title-sm", children: t }),
          r && /* @__PURE__ */ o("span", { className: "infobox-supporting-text text-body-sm", children: r })
        ] })
      ]
    }
  );
}
var Ee = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Warning = "warning", e.Success = "success", e))(Ee || {});
const dn = {
  [Ee.Default]: "text-on-default",
  [Ee.Error]: "text-on-error",
  [Ee.Warning]: "text-on-warning",
  [Ee.Success]: "text-on-success"
}, Ml = {
  [Ee.Default]: "bg-default-surface",
  [Ee.Error]: "bg-error-surface",
  [Ee.Warning]: "bg-warning-surface",
  [Ee.Success]: "bg-success-surface"
};
function vd({
  text: e,
  duration: t = 2e3,
  onClose: r,
  showClose: n,
  type: a = Ee.Default
}) {
  return de(() => {
    if (t) {
      const i = setTimeout(r, t);
      return () => clearTimeout(i);
    }
  }, [t, r]), /* @__PURE__ */ C(
    "div",
    {
      className: b(
        "transition-all duration-300 ease-out",
        "z-99 bottom-0",
        "flex w-full items-center justify-between gap-xxs rounded-md py-sm pl-md pr-sm",
        Ml[a]
      ),
      children: [
        /* @__PURE__ */ o("div", { className: b("w-full text-left text-body-md", dn[a]), children: e }),
        n && /* @__PURE__ */ o(
          Et,
          {
            className: b("h-5 w-5 cursor-pointer", dn[a]),
            onClick: r
          }
        )
      ]
    }
  );
}
function gd({
  color: e = "loading-indicator-color",
  size: t = "w-5 h-5",
  text: r,
  testId: n
}) {
  return /* @__PURE__ */ C("div", { className: "flex items-center justify-center gap-xs", children: [
    /* @__PURE__ */ o(Hn, { className: b("animate-spin", e, t), "data-testid": n }),
    r && /* @__PURE__ */ o("span", { className: b("text-body-sm", e), children: r })
  ] });
}
function Bl({ width: e = "w-full", height: t = "h-4" }) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "animate-pulse rounded-md bg-gradient-to-r from-shader-primary-light-8 bg-[length:1000px_100%] dark:from-shader-primary-dark-8",
        e,
        t
      )
    }
  );
}
function pd({
  children: e,
  className: t,
  hasSecondaryColors: r
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        "h-3 w-full animate-pulse rounded-full",
        r ? "skeleton-secondary-bg" : "skeleton-bg",
        t
      ),
      children: e
    }
  );
}
const Fl = {
  autoPlay: !0,
  muted: !0,
  playsInline: !0,
  controls: !0,
  controlsList: "nodownload",
  disablePictureInPicture: !0,
  preload: "auto",
  loop: !0,
  width: "100%",
  height: "auto"
}, Vl = {
  autoPlay: !0,
  muted: !0,
  playsInline: !0,
  controls: !1,
  disablePictureInPicture: !0,
  preload: "auto",
  loop: !0,
  width: "100%",
  height: "auto"
}, Ul = Fe(({ width: e = "100%", height: t = "auto", isAutoPlayEnabled: r, disableControls: n, ...a }, i) => /* @__PURE__ */ o("video", { ref: i, width: e, height: t, ...r ? n ? Vl : Fl : { preload: "metadata", autoPlay: !1 }, ...a, children: "Your browser does not support the video tag." }));
var Be = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Be || {}), Rr = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(Rr || {});
const Wl = "relative inline-flex items-center p-xxs border rounded-full cursor-pointer", Mt = {
  active: "toggle-bg-active toggle-border-active",
  inactive: "toggle-bg-inactive toggle-border-inactive",
  disabledActive: "toggle-bg-disabled-active toggle-border-disabled-active",
  disabled: "opacity-40 cursor-not-allowed"
}, jl = {
  [Be.Small]: "h-5 w-10",
  [Be.Default]: "h-6 w-12"
}, Gl = "absolute rounded-full transition-all duration-200 ease-in", fn = {
  [Be.Small]: {
    unchecked: "left-1",
    checked: "left-8 -translate-x-full"
  },
  [Be.Default]: {
    unchecked: "left-1",
    checked: "left-10 -translate-x-full"
  }
}, hn = {
  unchecked: "toggle-thumb-color",
  checked: "toggle-thumb-color-checked"
}, Hl = {
  [Be.Small]: "h-3 w-3",
  [Be.Default]: "h-4 w-4"
}, $l = "inline-flex items-center gap-2", zl = "text-label-lg toggle-label-color", bd = Fe(
  ({
    label: e,
    isToggled: t,
    labelPosition: r = Rr.Right,
    isDisabled: n = !1,
    onChange: a,
    name: i,
    size: c = Be.Default,
    testId: s
  }, d) => {
    const f = le(null);
    function g(S) {
      const E = S.target.checked;
      a == null || a(E, S);
    }
    function h(S) {
      d && (typeof d == "function" ? d(S) : d.current = S), f.current = S;
    }
    const x = b(Wl, {
      [Mt.active]: t && !n,
      [Mt.inactive]: !t,
      [Mt.disabledActive]: n && t,
      [Mt.disabled]: n,
      [jl[c]]: !0
    }), w = b(Gl, {
      [fn[c].unchecked]: !t,
      [fn[c].checked]: t,
      [hn.unchecked]: !t,
      [hn.checked]: t,
      [Hl[c]]: !0
    }), y = b($l, {
      "flex-row-reverse": r === Rr.Left,
      "cursor-not-allowed": n
    }), p = b(zl, {
      "opacity-40": n && !t
    });
    return /* @__PURE__ */ C("div", { className: y, children: [
      /* @__PURE__ */ o(
        "input",
        {
          id: i,
          name: i,
          type: "checkbox",
          className: "sr-only",
          checked: t,
          ref: h,
          disabled: n,
          onChange: g,
          "data-testid": s
        }
      ),
      /* @__PURE__ */ o(
        "span",
        {
          role: "switch",
          onClick: () => {
            var S;
            return (S = f.current) == null ? void 0 : S.click();
          },
          className: x,
          children: /* @__PURE__ */ o("span", { className: w })
        }
      ),
      e && /* @__PURE__ */ o("label", { htmlFor: i, className: p, children: e })
    ] });
  }
);
function Xl({
  text: e,
  isCopyable: t,
  isExternal: r,
  externalLink: n,
  copyText: a = e,
  onCopySuccess: i,
  onCopyError: c,
  onOpen: s
}) {
  async function d(g) {
    if (navigator.clipboard) {
      g == null || g.stopPropagation();
      try {
        await navigator.clipboard.writeText(a), i == null || i(g, a);
      } catch (h) {
        console.error("Failed to copy:", h), c == null || c(h, a);
      }
    }
  }
  function f(g) {
    if (g == null || g.stopPropagation(), n) {
      const h = window.open(n, "_blank", "noopener noreferrer");
      h && (h.opener = null);
    } else
      s == null || s(g);
  }
  return /* @__PURE__ */ C("div", { className: "address-text-color group flex flex-row items-center gap-1", children: [
    /* @__PURE__ */ o("span", { className: b("font-inter text-body-sm"), children: e }),
    t && /* @__PURE__ */ o(
      ce,
      {
        onClick: d,
        className: "opacity-0 group-hover:opacity-100",
        children: /* @__PURE__ */ o(Mr, {})
      }
    ),
    r && /* @__PURE__ */ o(
      ce,
      {
        onClick: f,
        className: "opacity-0 group-hover:opacity-100",
        children: /* @__PURE__ */ o(Ji, {})
      }
    )
  ] });
}
var qn = /* @__PURE__ */ ((e) => (e.Image = "image", e.Video = "video", e))(qn || {});
function Kl({
  src: e,
  isAutoPlayEnabled: t,
  assetType: r,
  altText: n,
  showFallback: a,
  disableControls: i
}) {
  return r === qn.Video ? /* @__PURE__ */ o(
    Ul,
    {
      src: e,
      isAutoPlayEnabled: t,
      disableControls: i
    }
  ) : a ? /* @__PURE__ */ o(Il, { src: e, alt: n }) : /* @__PURE__ */ o(Yn, { src: e, alt: n });
}
var K = /* @__PURE__ */ ((e) => (e.Outline = "outline", e.Elevated = "elevated", e.Success = "success", e.Brand = "brand", e.Error = "error", e))(K || {}), Dr = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(Dr || {});
const mn = "rounded-full", Zl = {
  [K.Outline]: "bg-transparent",
  [K.Elevated]: "chip-bg-elevated",
  [K.Success]: "bg-success-surface",
  [K.Brand]: "chip-bg-brand",
  [K.Error]: "bg-error-surface"
}, Yl = "outline outline-1 hover:chip-outline-color-hover active:chip-outline-color-active", ql = "hover:chip-bg-color-hover active:chip-bg-color-active group-focus:chip-bg-color-focus", Ql = `${Yl} ${ql}`, Jl = {
  [K.Outline]: "chip-bg-selected-outline"
}, ec = "chip-bg-selected-overlay", tc = {
  [K.Outline]: "chip-text-secondary"
}, rc = {
  [K.Outline]: "chip-border-default",
  [K.Elevated]: "border-transparent",
  [K.Success]: "border-success-surface",
  [K.Brand]: "chip-border-color-brand",
  [K.Error]: "border-error-surface"
}, nc = {
  [K.Outline]: "chip-text-default",
  [K.Elevated]: "chip-text-secondary",
  [K.Success]: "chip-text-secondary",
  [K.Brand]: "chip-text-brand",
  [K.Error]: "chip-text-secondary"
}, ac = "focus-visible:shadow-[0_0_0_2px] focus-visible:chip-focus-ring focus-visible:outline-none", oc = "chip-close-icon-opacity group-hover:opacity-100 group-focus:opacity-100 group-active:opacity-100";
function xd({
  label: e,
  type: t = K.Outline,
  selected: r,
  showClose: n,
  onClose: a,
  onClick: i,
  avatar: c,
  leadingElement: s,
  trailingElement: d,
  disabled: f,
  size: g = Dr.Default
}) {
  const h = t === K.Outline && r, x = r ? t === K.Outline ? "outline-transparent names:outline-names-neutral-20" : "chip-outline-color" : "outline-transparent", w = b(
    "group-focus:chip-outline-color-active",
    t === K.Outline && "names:group-focus:outline-transparent"
  ), y = r && !f && t !== K.Outline ? ec : "";
  return /* @__PURE__ */ o(
    ce,
    {
      onClick: i,
      className: b(
        "group border disabled:opacity-40",
        mn,
        h ? Jl[K.Outline] : Zl[t],
        r ? "border-transparent" : rc[t]
      ),
      disabled: f,
      children: /* @__PURE__ */ C(
        "span",
        {
          className: b(
            "flex h-full w-full flex-row items-center gap-x-2",
            c ? "py-xxs" : "py-[6px]",
            c ? "pl-xxs" : s ? "pl-xs" : "pl-sm",
            n ? "pr-xs" : "pr-sm",
            mn,
            h ? tc[K.Outline] : nc[t],
            x,
            !f && w,
            !f && Ql,
            ac,
            y
          ),
          children: [
            c ?? s,
            /* @__PURE__ */ o("span", { className: b(g === Dr.Small ? "text-label-md" : "text-body-md"), children: e }),
            d,
            n && /* @__PURE__ */ o(
              "div",
              {
                onClick: a,
                className: b(f ? "cursor-default" : "cursor-pointer"),
                children: /* @__PURE__ */ o(
                  Et,
                  {
                    className: b(
                      "h-4 w-4 transition-opacity duration-150",
                      f ? "" : r ? "opacity-100" : oc
                    )
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
}
var ut = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e.Transparent = "transparent", e))(ut || {});
const ic = {
  [ut.Outlined]: "bg-transparent",
  [ut.Filled]: "segmented-filled-bg-color",
  [ut.Transparent]: "bg-transparent"
}, lc = "border segmented-outlined-border";
function wd({
  type: e = ut.Filled,
  children: t,
  shape: r = st.Rounded
}) {
  const n = ic[e], a = e === ut.Outlined ? lc : "", i = r === st.Rounded ? "rounded-full gap-1 p-xxs" : "", c = r === st.Rounded ? "flex-wrap" : "flex-nowrap overflow-x-auto";
  return /* @__PURE__ */ o(
    "div",
    {
      className: b("flex flex-row", n, a, i, c),
      children: t
    }
  );
}
var ht = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(ht || {});
const cc = {
  [ht.Small]: "px-md py-sm--rs",
  [ht.Medium]: "px-md--rs py-sm--rs"
}, sc = {
  [ht.Small]: "text-title-md",
  [ht.Medium]: "text-title-lg"
};
function yd({
  title: e,
  subtitle: t,
  trailingElement: r,
  tooltipText: n,
  supportingElement: a,
  tooltipPosition: i,
  size: c = ht.Medium,
  testId: s
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("flex flex-row items-center justify-between", cc[c]),
      "data-testid": s,
      children: [
        /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-xxxs", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col justify-start", children: [
            /* @__PURE__ */ C("div", { className: "title-main-color flex flex-row items-center gap-x-0.5", children: [
              /* @__PURE__ */ o("h4", { className: b(sc[c]), children: e }),
              n && /* @__PURE__ */ o(vt, { text: n, position: i, children: /* @__PURE__ */ o(tr, { className: "title-icon-color" }) })
            ] }),
            /* @__PURE__ */ o("p", { className: "title-subtitle-color text-label-md", children: t })
          ] }),
          a
        ] }),
        r
      ]
    }
  );
}
function qt({ children: e, hasErrorStyles: t }) {
  return /* @__PURE__ */ o(
    "p",
    {
      className: b("secondary-text-color text-label-lg", {
        ["group-[.errored]:w-full group-[.errored]:secondary-text-error-color group-[.errored]:bg-error-surface group-[.errored]:rounded-xl group-[.errored]:py-1 group-[.errored]:px-2"]: t
      }),
      children: e
    }
  );
}
const Qn = "w-full input-caret-color bg-transparent text-body-lg caret-input-caret-color focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed", Jn = "input-text-color", ea = "input-placeholder-color", uc = "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none disabled:cursor-not-allowed", ta = "px-md py-sm rounded-lg border input-border-color input-border-color-disabled group-[.enabled]:cursor-text input-border-error-color hover:group-[.enabled]:input-border-color-hover input-border-color-focus", dc = "flex flex-col gap-y-2 text-label-lg input-label-color";
var ra = /* @__PURE__ */ ((e) => (e.Label = "label", e.Div = "div", e))(ra || {});
function Br({
  label: e,
  caption: t,
  disabled: r,
  errorMessage: n,
  amountCounter: a,
  required: i,
  labelHtmlTag: c = "label",
  children: s
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("group flex w-full flex-col gap-y-2", {
        "cursor-not-allowed opacity-40": r,
        errored: n,
        enabled: !r,
        required: i
      }),
      children: [
        e ? /* @__PURE__ */ C(fc, { labelHtmlTag: c, children: [
          e,
          s
        ] }) : s,
        (n || t || a) && /* @__PURE__ */ C(
          "div",
          {
            className: b(
              "flex flex-row items-center",
              t || n ? "justify-between gap-md" : "justify-end"
            ),
            children: [
              (n || t) && /* @__PURE__ */ o(qt, { hasErrorStyles: !0, children: n || t }),
              a && /* @__PURE__ */ o(qt, { children: a })
            ]
          }
        )
      ]
    }
  );
}
function fc({
  labelHtmlTag: e,
  children: t
}) {
  return oi(e, { className: dc }, t);
}
var Se = /* @__PURE__ */ ((e) => (e.Text = "text", e.Password = "password", e.Number = "number", e.NumericFormat = "numericFormat", e))(Se || {}), hc = /* @__PURE__ */ ((e) => (e.None = "none", e.Vertical = "vertical", e))(hc || {});
function na(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
var St;
(function(e) {
  e.event = "event", e.props = "prop";
})(St || (St = {}));
function Pe() {
}
function mc(e) {
  var t, r = void 0;
  return function() {
    for (var n = [], a = arguments.length; a--; ) n[a] = arguments[a];
    return t && n.length === t.length && n.every(function(i, c) {
      return i === t[c];
    }) || (t = n, r = e.apply(void 0, n)), r;
  };
}
function Ct(e) {
  return !!(e || "").match(/\d/);
}
function dt(e) {
  return e == null;
}
function vc(e) {
  return typeof e == "number" && isNaN(e);
}
function aa(e) {
  return dt(e) || vc(e) || typeof e == "number" && !isFinite(e);
}
function oa(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function gc(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function pc(e, t, r) {
  var n = gc(r), a = e.search(/[1-9]/);
  return a = a === -1 ? e.length : a, e.substring(0, a) + e.substring(a, e.length).replace(n, "$1" + t);
}
function bc(e) {
  var t = le(e);
  t.current = e;
  var r = le(function() {
    for (var n = [], a = arguments.length; a--; ) n[a] = arguments[a];
    return t.current.apply(t, n);
  });
  return r.current;
}
function Fr(e, t) {
  t === void 0 && (t = !0);
  var r = e[0] === "-", n = r && t;
  e = e.replace("-", "");
  var a = e.split("."), i = a[0], c = a[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: c,
    hasNegation: r,
    addNegation: n
  };
}
function xc(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var r = e.split("."), n = r[0].replace(/^0+/, "") || "0", a = r[1] || "";
  return (t ? "-" : "") + n + (a ? "." + a : "");
}
function ia(e, t, r) {
  for (var n = "", a = r ? "0" : "", i = 0; i <= t - 1; i++)
    n += e[i] || a;
  return n;
}
function vn(e, t) {
  return Array(t + 1).join(e);
}
function la(e) {
  var t = e + "", r = t[0] === "-" ? "-" : "";
  r && (t = t.substring(1));
  var n = t.split(/[eE]/g), a = n[0], i = n[1];
  if (i = Number(i), !i)
    return r + a;
  a = a.replace(".", "");
  var c = 1 + i, s = a.length;
  return c < 0 ? a = "0." + vn("0", Math.abs(c)) + a : c >= s ? a = a + vn("0", c - s) : a = (a.substring(0, c) || "0") + "." + a.substring(c), r + a;
}
function gn(e, t, r) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var n = (e.indexOf(".") !== -1 || r) && t, a = Fr(e), i = a.beforeDecimal, c = a.afterDecimal, s = a.hasNegation, d = parseFloat("0." + (c || "0")), f = c.length <= t ? "0." + c : d.toFixed(t), g = f.split("."), h = i;
  i && Number(g[0]) && (h = i.split("").reverse().reduce(function(p, S, E) {
    return p.length > E ? (Number(p[0]) + Number(S)).toString() + p.substring(1, p.length) : S + p;
  }, g[0]));
  var x = ia(g[1] || "", t, r), w = s ? "-" : "", y = n ? "." : "";
  return "" + w + h + y + x;
}
function $e(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var r = e.createTextRange();
      return r.move("character", t), r.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var ca = mc(function(e, t) {
  for (var r = 0, n = 0, a = e.length, i = t.length; e[r] === t[r] && r < a; )
    r++;
  for (; e[a - 1 - n] === t[i - 1 - n] && i - n > r && a - n > r; )
    n++;
  return {
    from: { start: r, end: a - n },
    to: { start: r, end: i - n }
  };
}), wc = function(e, t) {
  var r = Math.min(e.selectionStart, t);
  return {
    from: { start: r, end: e.selectionEnd },
    to: { start: r, end: t }
  };
};
function yc(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function xr(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function Sc() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function Cc(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function Ec(e) {
  var t = e.currentValue, r = e.formattedValue, n = e.currentValueIndex, a = e.formattedValueIndex;
  return t[n] === r[a];
}
function Nc(e, t, r, n, a, i, c) {
  c === void 0 && (c = Ec);
  var s = a.findIndex(function(T) {
    return T;
  }), d = e.slice(0, s);
  !t && !r.startsWith(d) && (t = d, r = d + r, n = n + d.length);
  for (var f = r.length, g = e.length, h = {}, x = new Array(f), w = 0; w < f; w++) {
    x[w] = -1;
    for (var y = 0, p = g; y < p; y++) {
      var S = c({
        currentValue: r,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: w,
        formattedValueIndex: y
      });
      if (S && h[y] !== !0) {
        x[w] = y, h[y] = !0;
        break;
      }
    }
  }
  for (var E = n; E < f && (x[E] === -1 || !i(r[E])); )
    E++;
  var D = E === f || x[E] === -1 ? g : x[E];
  for (E = n - 1; E > 0 && x[E] === -1; )
    E--;
  var N = E === -1 || x[E] === -1 ? 0 : x[E] + 1;
  return N > D ? D : n - N < D - n ? N : D;
}
function pn(e, t, r, n) {
  var a = e.length;
  if (t = yc(t, 0, a), n === "left") {
    for (; t >= 0 && !r[t]; )
      t--;
    t === -1 && (t = r.indexOf(!0));
  } else {
    for (; t <= a && !r[t]; )
      t++;
    t > a && (t = r.lastIndexOf(!0));
  }
  return t === -1 && (t = a), t;
}
function _c(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), r = 0, n = t.length; r < n; r++)
    t[r] = !!(Ct(e[r]) || Ct(e[r - 1]));
  return t;
}
function sa(e, t, r, n, a, i) {
  i === void 0 && (i = Pe);
  var c = bc(function(y, p) {
    var S, E;
    return aa(y) ? (E = "", S = "") : typeof y == "number" || p ? (E = typeof y == "number" ? la(y) : y, S = n(E)) : (E = a(y, void 0), S = n(E)), { formattedValue: S, numAsString: E };
  }), s = he(function() {
    return c(dt(e) ? t : e, r);
  }), d = s[0], f = s[1], g = function(y, p) {
    y.formattedValue !== d.formattedValue && f({
      formattedValue: y.formattedValue,
      numAsString: y.value
    }), i(y, p);
  }, h = e, x = r;
  dt(e) && (h = d.numAsString, x = !0);
  var w = c(h, x);
  return ii(function() {
    f(w);
  }, [w.formattedValue]), [d, g];
}
function Oc(e) {
  return e.replace(/[^0-9]/g, "");
}
function Ac(e) {
  return e;
}
function Rc(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var r = e.displayType;
  r === void 0 && (r = "input");
  var n = e.customInput, a = e.renderText, i = e.getInputRef, c = e.format;
  c === void 0 && (c = Ac);
  var s = e.removeFormatting;
  s === void 0 && (s = Oc);
  var d = e.defaultValue, f = e.valueIsNumericString, g = e.onValueChange, h = e.isAllowed, x = e.onChange;
  x === void 0 && (x = Pe);
  var w = e.onKeyDown;
  w === void 0 && (w = Pe);
  var y = e.onMouseUp;
  y === void 0 && (y = Pe);
  var p = e.onFocus;
  p === void 0 && (p = Pe);
  var S = e.onBlur;
  S === void 0 && (S = Pe);
  var E = e.value, D = e.getCaretBoundary;
  D === void 0 && (D = _c);
  var N = e.isValidInputCharacter;
  N === void 0 && (N = Ct);
  var T = e.isCharacterSame, P = na(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), L = sa(E, d, !!f, c, s, g), _ = L[0], I = _.formattedValue, k = _.numAsString, q = L[1], ae = le(), be = le({ formattedValue: I, numAsString: k }), xe = function(O, R) {
    be.current = { formattedValue: O.formattedValue, numAsString: O.value }, q(O, R);
  }, Le = he(!1), Ve = Le[0], F = Le[1], M = le(null), X = le({
    setCaretTimeout: null,
    focusTimeout: null
  });
  de(function() {
    return F(!0), function() {
      clearTimeout(X.current.setCaretTimeout), clearTimeout(X.current.focusTimeout);
    };
  }, []);
  var ee = c, re = function(O, R) {
    var B = parseFloat(R);
    return {
      formattedValue: O,
      value: R,
      floatValue: isNaN(B) ? void 0 : B
    };
  }, Q = function(O, R, B) {
    O.selectionStart === 0 && O.selectionEnd === O.value.length || ($e(O, R), X.current.setCaretTimeout = setTimeout(function() {
      O.value === B && O.selectionStart !== R && $e(O, R);
    }, 0));
  }, ne = function(O, R, B) {
    return pn(O, R, D(O), B);
  }, j = function(O, R, B) {
    var H = D(R), oe = Nc(R, I, O, B, H, N, T);
    return oe = pn(R, oe, H), oe;
  }, Je = function(O) {
    var R = O.formattedValue;
    R === void 0 && (R = "");
    var B = O.input, H = O.source, oe = O.event, $ = O.numAsString, V;
    if (B) {
      var ue = O.inputValue || B.value, me = xr(B);
      B.value = R, V = j(ue, R, me), V !== void 0 && Q(B, V, R);
    }
    R !== I && xe(re(R, $), { event: oe, source: H });
  };
  de(function() {
    var O = be.current, R = O.formattedValue, B = O.numAsString;
    (I !== R || k !== B) && xe(re(I, k), {
      event: void 0,
      source: St.props
    });
  }, [I, k]);
  var Ue = M.current ? xr(M.current) : void 0, we = typeof window < "u" ? Ar : de;
  we(function() {
    var O = M.current;
    if (I !== be.current.formattedValue && O) {
      var R = j(be.current.formattedValue, I, Ue);
      O.value = I, Q(O, R, I);
    }
  }, [I]);
  var et = function(O, R, B) {
    var H = R.target, oe = ae.current ? wc(ae.current, H.selectionEnd) : ca(I, O), $ = Object.assign(Object.assign({}, oe), { lastValue: I }), V = s(O, $), ue = ee(V);
    if (V = s(ue, void 0), h && !h(re(ue, V))) {
      var me = R.target, ye = xr(me), pt = j(O, I, ye);
      return me.value = I, Q(me, pt, I), !1;
    }
    return Je({
      formattedValue: ue,
      numAsString: V,
      inputValue: O,
      event: R,
      source: B,
      input: R.target
    }), !0;
  }, Ae = function(O, R) {
    R === void 0 && (R = 0);
    var B = O.selectionStart, H = O.selectionEnd;
    ae.current = { selectionStart: B, selectionEnd: H + R };
  }, Nt = function(O) {
    var R = O.target, B = R.value, H = et(B, O, St.event);
    H && x(O), ae.current = void 0;
  }, gt = function(O) {
    var R = O.target, B = O.key, H = R.selectionStart, oe = R.selectionEnd, $ = R.value;
    $ === void 0 && ($ = "");
    var V;
    B === "ArrowLeft" || B === "Backspace" ? V = Math.max(H - 1, 0) : B === "ArrowRight" ? V = Math.min(H + 1, $.length) : B === "Delete" && (V = H);
    var ue = 0;
    B === "Delete" && H === oe && (ue = 1);
    var me = B === "ArrowLeft" || B === "ArrowRight";
    if (V === void 0 || H !== oe && !me) {
      w(O), Ae(R, ue);
      return;
    }
    var ye = V;
    if (me) {
      var pt = B === "ArrowLeft" ? "left" : "right";
      ye = ne($, V, pt), ye !== V && O.preventDefault();
    } else B === "Delete" && !N($[V]) ? ye = ne($, V, "right") : B === "Backspace" && !N($[V]) && (ye = ne($, V, "left"));
    ye !== V && Q(R, ye, $), w(O), Ae(R, ue);
  }, _t = function(O) {
    var R = O.target, B = function() {
      var H = R.selectionStart, oe = R.selectionEnd, $ = R.value;
      if ($ === void 0 && ($ = ""), H === oe) {
        var V = ne($, H);
        V !== H && Q(R, V, $);
      }
    };
    B(), requestAnimationFrame(function() {
      B();
    }), y(O), Ae(R);
  }, Ot = function(O) {
    O.persist && O.persist();
    var R = O.target, B = O.currentTarget;
    M.current = R, X.current.focusTimeout = setTimeout(function() {
      var H = R.selectionStart, oe = R.selectionEnd, $ = R.value;
      $ === void 0 && ($ = "");
      var V = ne($, H);
      V !== H && !(H === 0 && oe === $.length) && Q(R, V, $), p(Object.assign(Object.assign({}, O), { currentTarget: B }));
    }, 0);
  }, or = function(O) {
    M.current = null, clearTimeout(X.current.focusTimeout), clearTimeout(X.current.setCaretTimeout), S(O);
  }, ir = Ve && Sc() ? "numeric" : void 0, At = Object.assign({ inputMode: ir }, P, {
    type: t,
    value: I,
    onChange: Nt,
    onKeyDown: gt,
    onMouseUp: _t,
    onFocus: Ot,
    onBlur: or
  });
  if (r === "text")
    return a ? it.createElement(it.Fragment, null, a(I, P) || null) : it.createElement("span", Object.assign({}, P, { ref: i }), I);
  if (n) {
    var lr = n;
    return it.createElement(lr, Object.assign({}, At, { ref: i }));
  }
  return it.createElement("input", Object.assign({}, At, { ref: i }));
}
function bn(e, t) {
  var r = t.decimalScale, n = t.fixedDecimalScale, a = t.prefix;
  a === void 0 && (a = "");
  var i = t.suffix;
  i === void 0 && (i = "");
  var c = t.allowNegative, s = t.thousandsGroupStyle;
  if (s === void 0 && (s = "thousand"), e === "" || e === "-")
    return e;
  var d = rr(t), f = d.thousandSeparator, g = d.decimalSeparator, h = r !== 0 && e.indexOf(".") !== -1 || r && n, x = Fr(e, c), w = x.beforeDecimal, y = x.afterDecimal, p = x.addNegation;
  return r !== void 0 && (y = ia(y, r, !!n)), f && (w = pc(w, f, s)), a && (w = a + w), i && (y = y + i), p && (w = "-" + w), e = w + (h && g || "") + y, e;
}
function rr(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var r = e.thousandSeparator, n = e.allowedDecimalSeparators;
  return r === !0 && (r = ","), n || (n = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: r,
    allowedDecimalSeparators: n
  };
}
function Dc(e, t) {
  e === void 0 && (e = "");
  var r = new RegExp("(-)"), n = new RegExp("(-)(.)*(-)"), a = r.test(e), i = n.test(e);
  return e = e.replace(/-/g, ""), a && !i && t && (e = "-" + e), e;
}
function Tc(e, t) {
  return new RegExp("(^-)|[0-9]|" + oa(e), "g");
}
function Lc(e, t, r) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(r != null && r.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function Ic(e, t, r) {
  var n;
  t === void 0 && (t = Cc(e));
  var a = r.allowNegative, i = r.prefix;
  i === void 0 && (i = "");
  var c = r.suffix;
  c === void 0 && (c = "");
  var s = r.decimalScale, d = t.from, f = t.to, g = f.start, h = f.end, x = rr(r), w = x.allowedDecimalSeparators, y = x.decimalSeparator, p = e[h] === y;
  if (Ct(e) && (e === i || e === c) && t.lastValue === "")
    return e;
  if (h - g === 1 && w.indexOf(e[g]) !== -1) {
    var S = s === 0 ? "" : y;
    e = e.substring(0, g) + S + e.substring(g + 1, e.length);
  }
  var E = function(M, X, ee) {
    var re = !1, Q = !1;
    i.startsWith("-") ? re = !1 : M.startsWith("--") ? (re = !1, Q = !0) : c.startsWith("-") && M.length === c.length ? re = !1 : M[0] === "-" && (re = !0);
    var ne = re ? 1 : 0;
    return Q && (ne = 2), ne && (M = M.substring(ne), X -= ne, ee -= ne), { value: M, start: X, end: ee, hasNegation: re };
  }, D = E(e, g, h), N = D.hasNegation;
  n = D, e = n.value, g = n.start, h = n.end;
  var T = E(t.lastValue, d.start, d.end), P = T.start, L = T.end, _ = T.value, I = e.substring(g, h);
  e.length && _.length && (P > _.length - c.length || L < i.length) && !(I && c.startsWith(I)) && (e = _);
  var k = 0;
  e.startsWith(i) ? k += i.length : g < i.length && (k = g), e = e.substring(k), h -= k;
  var q = e.length, ae = e.length - c.length;
  e.endsWith(c) ? q = ae : (h > ae || h > e.length - c.length) && (q = h), e = e.substring(0, q), e = Dc(N ? "-" + e : e, a), e = (e.match(Tc(y)) || []).join("");
  var be = e.indexOf(y);
  e = e.replace(new RegExp(oa(y), "g"), function(M, X) {
    return X === be ? "." : "";
  });
  var xe = Fr(e, a), Le = xe.beforeDecimal, Ve = xe.afterDecimal, F = xe.addNegation;
  return f.end - f.start < d.end - d.start && Le === "" && p && !parseFloat(Ve) && (e = F ? "-" : ""), e;
}
function Pc(e, t) {
  var r = t.prefix;
  r === void 0 && (r = "");
  var n = t.suffix;
  n === void 0 && (n = "");
  var a = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), i = e[0] === "-";
  a.fill(!1, 0, r.length + (i ? 1 : 0));
  var c = e.length;
  return a.fill(!1, c - n.length + 1, c + 1), a;
}
function kc(e) {
  var t = rr(e), r = t.thousandSeparator, n = t.decimalSeparator, a = e.prefix;
  a === void 0 && (a = "");
  var i = e.allowNegative;
  if (i === void 0 && (i = !0), r === n)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + r + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + n + ` (default value for decimalSeparator is .)
     `);
  return a.startsWith("-") && i && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + a + `
      allowNegative: ` + i + `
    `), i = !1), Object.assign(Object.assign({}, e), { allowNegative: i });
}
function Mc(e) {
  e = kc(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, r = e.allowNegative, n = e.allowLeadingZeros, a = e.onKeyDown;
  a === void 0 && (a = Pe);
  var i = e.onBlur;
  i === void 0 && (i = Pe);
  var c = e.thousandSeparator, s = e.decimalScale, d = e.fixedDecimalScale, f = e.prefix;
  f === void 0 && (f = "");
  var g = e.defaultValue, h = e.value, x = e.valueIsNumericString, w = e.onValueChange, y = na(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), p = rr(e), S = p.decimalSeparator, E = p.allowedDecimalSeparators, D = function(F) {
    return bn(F, e);
  }, N = function(F, M) {
    return Ic(F, M, e);
  }, T = dt(h) ? g : h, P = x ?? Lc(T, f, t);
  dt(h) ? dt(g) || (P = P || typeof g == "number") : P = P || typeof h == "number";
  var L = function(F) {
    return aa(F) ? F : (typeof F == "number" && (F = la(F)), P && typeof s == "number" ? gn(F, s, !!d) : F);
  }, _ = sa(L(h), L(g), !!P, D, N, w), I = _[0], k = I.numAsString, q = I.formattedValue, ae = _[1], be = function(F) {
    var M = F.target, X = F.key, ee = M.selectionStart, re = M.selectionEnd, Q = M.value;
    if (Q === void 0 && (Q = ""), (X === "Backspace" || X === "Delete") && re < f.length) {
      F.preventDefault();
      return;
    }
    if (ee !== re) {
      a(F);
      return;
    }
    X === "Backspace" && Q[0] === "-" && ee === f.length + 1 && r && $e(M, 1), s && d && (X === "Backspace" && Q[ee - 1] === S ? ($e(M, ee - 1), F.preventDefault()) : X === "Delete" && Q[ee] === S && F.preventDefault()), E != null && E.includes(X) && Q[ee] === S && $e(M, ee + 1);
    var ne = c === !0 ? "," : c;
    X === "Backspace" && Q[ee - 1] === ne && $e(M, ee - 1), X === "Delete" && Q[ee] === ne && $e(M, ee + 1), a(F);
  }, xe = function(F) {
    var M = k;
    if (M.match(/\d/g) || (M = ""), n || (M = xc(M)), d && s && (M = gn(M, s, d)), M !== k) {
      var X = bn(M, e);
      ae({
        formattedValue: X,
        value: M,
        floatValue: parseFloat(M)
      }, {
        event: F,
        source: St.event
      });
    }
    i(F);
  }, Le = function(F) {
    return F === S ? !0 : Ct(F);
  }, Ve = function(F) {
    var M = F.currentValue, X = F.lastValue, ee = F.formattedValue, re = F.currentValueIndex, Q = F.formattedValueIndex, ne = M[re], j = ee[Q], Je = ca(X, M), Ue = Je.to, we = function(et) {
      return N(et).indexOf(".") + f.length;
    };
    return h === 0 && d && s && M[Ue.start] === S && we(M) < re && we(ee) > Q ? !1 : re >= Ue.start && re < Ue.end && E && E.includes(ne) && j === S ? !0 : ne === j;
  };
  return Object.assign(Object.assign({}, y), {
    value: q,
    valueIsNumericString: !1,
    isValidInputCharacter: Le,
    isCharacterSame: Ve,
    onValueChange: ae,
    format: D,
    removeFormatting: N,
    getCaretBoundary: function(F) {
      return Pc(F, e);
    },
    onKeyDown: be,
    onBlur: xe
  });
}
function Bc(e) {
  var t = Mc(e);
  return it.createElement(Rc, Object.assign({}, t));
}
const Sd = Fe(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: a,
  leadingIcon: i,
  supportingText: c,
  amountCounter: s,
  trailingElement: d,
  isContentVisible: f,
  value: g,
  supportingValue: h,
  defaultValue: x,
  onClearInput: w,
  isVisibilityToggleEnabled: y,
  type: p,
  ...S
}, E) {
  y ?? (y = p === Se.Password);
  const D = le(null), [N, T] = he(
    f ?? p !== Se.Password
  );
  de(() => {
    T(f ?? p !== Se.Password);
  }, [p, f]);
  function P() {
    T((_) => !_);
  }
  function L() {
    var _;
    D.current && ((_ = D.current.querySelector("input")) == null || _.focus());
  }
  return /* @__PURE__ */ o(
    Br,
    {
      label: t,
      caption: r,
      disabled: n,
      errorMessage: a,
      amountCounter: s,
      required: S.required,
      children: /* @__PURE__ */ C(
        "div",
        {
          className: b("relative flex flex-row items-center gap-x-3", ta),
          onClick: L,
          ref: D,
          children: [
            i && /* @__PURE__ */ o("span", { className: "input-icon-color", children: i }),
            /* @__PURE__ */ C("div", { className: "flex flex-1 flex-col items-start", children: [
              /* @__PURE__ */ o(
                Fc,
                {
                  ...S,
                  inputRef: E,
                  value: g,
                  type: p === Se.Password && N ? Se.Text : p,
                  disabled: n,
                  className: b(
                    Qn,
                    Jn,
                    ea,
                    uc
                  )
                }
              ),
              h && /* @__PURE__ */ o("span", { className: "text-label-md text-iota-neutral-60 names:text-iota-neutral-60 dark:text-iota-neutral-40", children: h })
            ] }),
            c && /* @__PURE__ */ o(qt, { children: c }),
            /* @__PURE__ */ o(
              Uc,
              {
                value: g,
                type: p,
                onClearInput: w,
                isContentVisible: N,
                trailingElement: d,
                isVisibilityToggleEnabled: y,
                onToggleButtonClick: P
              }
            )
          ]
        }
      )
    }
  );
});
function Fc({
  type: e,
  inputRef: t,
  ...r
}) {
  function n(a) {
    if (e === Se.Number) {
      const i = a.currentTarget;
      i.blur(), a.stopPropagation(), setTimeout(() => {
        i.focus({ preventScroll: !0 });
      }, 0);
    }
  }
  return e === Se.NumericFormat ? /* @__PURE__ */ o(Vc, { inputRef: t, ...r, type: e }) : /* @__PURE__ */ o(
    "input",
    {
      ref: t,
      ...r,
      type: e,
      onWheel: (a) => {
        var i;
        n(a), (i = r.onWheel) == null || i.call(r, a);
      }
    }
  );
}
function Vc({
  inputRef: e,
  className: t,
  type: r,
  ...n
}) {
  return /* @__PURE__ */ o(
    Bc,
    {
      className: t,
      valueIsNumericString: !0,
      getInputRef: e,
      ...n
    }
  );
}
function Uc({
  value: e,
  type: t,
  onClearInput: r,
  isContentVisible: n,
  trailingElement: a,
  onToggleButtonClick: i,
  isVisibilityToggleEnabled: c
}) {
  const s = !!(t === Se.Text && e && r), d = !!(t === Se.Password && c), f = !!(a && !s && !d);
  if (s)
    return /* @__PURE__ */ o(
      ce,
      {
        className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
        onClick: r,
        tabIndex: -1,
        children: /* @__PURE__ */ o(Et, {})
      }
    );
  if (d)
    return /* @__PURE__ */ o(
      ce,
      {
        onClick: i,
        className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
        tabIndex: -1,
        children: n ? /* @__PURE__ */ o(Kn, {}) : /* @__PURE__ */ o(Xn, {})
      }
    );
  if (f)
    return /* @__PURE__ */ o(li, { children: a });
}
const Cd = Fe(function({
  label: t,
  caption: r,
  disabled: n,
  errorMessage: a,
  value: i,
  amountCounter: c,
  isVisibilityToggleEnabled: s,
  isResizeEnabled: d,
  required: f,
  isContentVisible: g,
  ...h
}, x) {
  const [w, y] = he(
    g ?? !0
  );
  de(() => {
    y(g ?? !0);
  }, [g]);
  function p() {
    y((S) => !S);
  }
  return /* @__PURE__ */ o(
    Br,
    {
      label: t,
      caption: r,
      disabled: n || !w,
      errorMessage: a,
      amountCounter: c,
      required: f,
      children: /* @__PURE__ */ C("div", { className: "relative", children: [
        /* @__PURE__ */ o(
          "textarea",
          {
            disabled: n || !w,
            required: f,
            ref: x,
            className: b(
              "peer block min-h-[50px]",
              ta,
              Qn,
              Jn,
              ea,
              w && d ? "resize-y" : "resize-none",
              !w && "not-visible select-none text-transparent dark:text-transparent"
            ),
            value: w ? i : "",
            ...h
          }
        ),
        !w && /* @__PURE__ */ o("div", { className: "absolute left-0 top-0 flex h-full w-full flex-col items-stretch gap-y-2 px-md py-sm peer-[.not-visible]:select-none", children: /* @__PURE__ */ o(Wc, { rows: 3, halfWidthRow: 3 }) }),
        s && /* @__PURE__ */ o("span", { className: "absolute bottom-4 right-4 flex", children: /* @__PURE__ */ o(
          ce,
          {
            onClick: p,
            className: "input-icon-color [&_svg]:h-5 [&_svg]:w-5",
            tabIndex: -1,
            children: w ? /* @__PURE__ */ o(Kn, {}) : /* @__PURE__ */ o(Xn, {})
          }
        ) })
      ] })
    }
  );
});
function Wc({ rows: e, halfWidthRow: t }) {
  return /* @__PURE__ */ o(Ze, { children: Array.from({ length: e }).map((r, n) => {
    const i = t === n + 1 ? "w-1/2" : "w-full";
    return /* @__PURE__ */ o("div", { className: `input-visibility-bar h-2.5 rounded ${i}` }, n);
  }) });
}
var Vr = /* @__PURE__ */ ((e) => (e.Horizontal = "horizontal", e.Vertical = "vertical", e))(Vr || {});
const ua = "navbar-item-icon-selected-color", da = "navbar-item-icon-color", jc = "py-xxs px-sm", Gc = "p-sm", fa = "bg-shader-primary-light-12 dark:bg-shader-primary-dark-12", Hc = "-top-3 right-3", $c = "-top-1 right-3", ha = "navbar-item-label-selected-color", ma = "navbar-item-label-color";
function zc({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: a,
  isDisabled: i = !1
}) {
  const c = r ? ua : da, s = t ? jc : Gc, d = r && fa, f = t ? Hc : $c, g = r ? ha : ma, h = i ? "cursor-not-allowed opacity-60" : "state-layer";
  return /* @__PURE__ */ C(
    "div",
    {
      onClick: (w) => {
        if (i) {
          w.preventDefault();
          return;
        }
        a == null || a(w);
      },
      className: b(
        "inline-flex cursor-pointer flex-col items-center justify-center space-y-1"
      ),
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: b(
              "relative inline-flex rounded-full",
              s,
              d,
              h
            ),
            children: [
              /* @__PURE__ */ o("div", { className: b("inline-flex [&_svg]:h-6 [&_svg]:w-6", c), children: e }),
              n && /* @__PURE__ */ o("div", { className: b("absolute", f), children: /* @__PURE__ */ o(Yt, { type: te.PrimarySolid }) })
            ]
          }
        ),
        t && /* @__PURE__ */ o("span", { className: b("text-center text-label-md", g), children: t })
      ]
    }
  );
}
function Xc({
  icon: e,
  text: t,
  isSelected: r,
  hasBadge: n,
  onClick: a,
  isDisabled: i = !1
}) {
  const c = r ? ua : da, s = r && fa, d = r ? ha : ma;
  return /* @__PURE__ */ C(
    "div",
    {
      onClick: (h) => {
        if (i) {
          h.preventDefault();
          return;
        }
        a == null || a(h);
      },
      className: b(
        "relative inline-flex w-full flex-row items-center justify-between rounded-full p-sm",
        s,
        i ? "cursor-not-allowed opacity-60" : "state-layer cursor-pointer "
      ),
      children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ o("div", { className: b("inline-flex [&_svg]:h-6 [&_svg]:w-6", c), children: e }),
          t && /* @__PURE__ */ o("span", { className: b("text-center text-label-lg", d), children: t })
        ] }),
        n && /* @__PURE__ */ o(Yt, { type: te.PrimarySolid })
      ]
    }
  );
}
function va(e) {
  const { type: t, text: r } = e;
  return t === Vr.Vertical && r ? /* @__PURE__ */ o(Xc, { ...e }) : /* @__PURE__ */ o(zc, { ...e });
}
function Ed({
  title: e,
  subtitle: t,
  badgeType: r,
  badgeText: n,
  isLocked: a,
  avatarContent: i,
  onOptionsClick: c,
  onLockAccountClick: s,
  onUnlockAccountClick: d,
  onCopy: f,
  copyText: g,
  onOpen: h,
  isCopyable: x,
  isExternal: w,
  isSelected: y,
  isActive: p,
  showSelected: S,
  badgeTooltipText: E,
  badgeTooltipPosition: D = He.Bottom
}) {
  const N = i;
  return /* @__PURE__ */ C(
    "div",
    {
      className: b(
        "state-layer group relative flex w-full items-center justify-between space-x-3 rounded-xl px-sm py-xs hover:cursor-pointer",
        p && "state-active",
        {
          "opacity-60": a && S
        }
      ),
      children: [
        /* @__PURE__ */ C("div", { className: "flex items-center space-x-3", children: [
          /* @__PURE__ */ o(N, { isLocked: a }),
          /* @__PURE__ */ C("div", { className: "flex flex-col items-start py-xs", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center space-x-2", children: [
              /* @__PURE__ */ o("span", { className: "account-title-color font-inter text-title-md", children: e }),
              n && r ? E ? /* @__PURE__ */ o(vt, { text: E, position: D, children: /* @__PURE__ */ o(Yt, { type: r, label: n }) }) : /* @__PURE__ */ o(Yt, { type: r, label: n }) : null
            ] }),
            /* @__PURE__ */ o(
              Xl,
              {
                text: t,
                onCopySuccess: f,
                copyText: g,
                onOpen: h,
                isCopyable: x,
                isExternal: w
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "z-10 ml-auto flex items-center space-x-2 [&_button]:h-5 [&_button]:w-5 [&_svg]:h-5 [&_svg]:w-5", children: [
          /* @__PURE__ */ C("div", { className: "account-icon-color flex items-center space-x-2 [&_button:not(.locked)]:hidden group-hover:[&_button:not(.locked)]:flex", children: [
            c && /* @__PURE__ */ o(ce, { onClick: c, children: /* @__PURE__ */ o($n, {}) }),
            s && d && (a ? /* @__PURE__ */ o("div", { className: "flex items-center", children: /* @__PURE__ */ o(
              ce,
              {
                onClick: d,
                testId: "account-unlock",
                className: "locked",
                children: /* @__PURE__ */ o(il, {})
              }
            ) }) : /* @__PURE__ */ o(ce, { onClick: s, testId: "account-lock", children: /* @__PURE__ */ o(ll, {}) }))
          ] }),
          S && /* @__PURE__ */ o(ce, { children: y ? /* @__PURE__ */ o(tl, { className: "account-check-active-color h-5 w-5" }) : /* @__PURE__ */ o(zn, { className: "account-check-inactive-color h-5 w-5" }) })
        ] })
      ]
    }
  );
}
function Kc({ children: e }) {
  return /* @__PURE__ */ o("ul", { className: "dropdown-bg dropdown-border-color list-none rounded-lg border py-xs", children: e });
}
var Ht = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e))(Ht || {});
function Zc({
  children: e,
  hasLastBorderNoneClass: t,
  isContentCentered: r
}) {
  return /* @__PURE__ */ o(
    "td",
    {
      className: b(
        "table-cell-border-color h-14  border-b px-md",
        { "last:border-none": t },
        { "flex items-center justify-center": r }
      ),
      children: e
    }
  );
}
function Nd({
  children: e,
  supportingLabel: t
}) {
  return /* @__PURE__ */ C("div", { className: "flex flex-row items-baseline gap-1", children: [
    /* @__PURE__ */ o("span", { children: e }),
    t && /* @__PURE__ */ o("span", { className: "table-cell-supporting-label-color text-body-sm", children: t })
  ] });
}
function _d() {
  return /* @__PURE__ */ o(Bl, {});
}
var $t = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))($t || {});
const Od = Fe(
  ({
    disabled: e,
    label: t,
    leadingIcon: r,
    supportingText: n,
    errorMessage: a,
    caption: i,
    options: c,
    placeholder: s,
    onValueChange: d,
    onOptionClick: f,
    value: g,
    dropdownPosition: h = Ht.Bottom,
    size: x = $t.Default
  }, w) => {
    const [y, p] = he(!1), S = P(g, c), E = le(null), D = S || s, N = x === $t.Small ? "px-sm" : "px-md", T = x === $t.Small ? "text-body-md" : "text-body-lg";
    de(() => {
      e && y && I();
    }, [e, y]), de(() => {
      if (!y) return;
      const k = (q) => {
        const ae = q.target;
        E.current && !E.current.contains(ae) && I();
      };
      return document.addEventListener("mousedown", k), () => {
        document.removeEventListener("mousedown", k);
      };
    }, [y]);
    function P(k, q = []) {
      return q.find(
        (ae) => typeof ae == "string" ? ae === k : ae.id === k
      ) ?? q[0];
    }
    function L() {
      p((k) => !k);
    }
    function _(k) {
      I();
      const q = typeof k == "string" ? k : k.id;
      f == null || f(q), k !== S && (d == null || d(q));
    }
    function I() {
      p(!1);
    }
    return /* @__PURE__ */ o(
      Br,
      {
        label: t,
        caption: i,
        disabled: e,
        errorMessage: a,
        labelHtmlTag: ra.Div,
        children: /* @__PURE__ */ C("div", { className: "relative flex w-full flex-col", ref: E, children: [
          /* @__PURE__ */ C(
            ce,
            {
              ref: w,
              onClick: L,
              disabled: e,
              className: b(
                "select-border-color focus-visible:enabled:select-border-focus-color active:enabled:select-border-focus-color group-[.errored]:select-border-error-color group-[.opened]:select-border-focus-color [&:is(:focus,_:focus-visible,_:active)]:enabled:select-border-focus-color hover:enabled:select-border-hover-color flex flex-row items-center gap-x-3 rounded-lg border py-sm disabled:cursor-not-allowed [&_svg]:h-5 [&_svg]:w-5",
                N
              ),
              children: [
                r && /* @__PURE__ */ o("span", { className: "select-icon-color", children: r }),
                /* @__PURE__ */ C("div", { className: "flex w-full flex-row items-baseline gap-x-3", children: [
                  D && /* @__PURE__ */ o(
                    "div",
                    {
                      className: b(
                        "select-label-color block w-full text-start",
                        T
                      ),
                      children: /* @__PURE__ */ o(xn, { option: D })
                    }
                  ),
                  n && /* @__PURE__ */ o("div", { className: "ml-auto", children: /* @__PURE__ */ o(qt, { children: n }) })
                ] }),
                /* @__PURE__ */ o(
                  hl,
                  {
                    className: b("select-icon-color transition-transform", {
                      " rotate-180": y
                    })
                  }
                )
              ]
            }
          ),
          y && /* @__PURE__ */ o(
            "div",
            {
              className: "fixed left-0 top-0 z-[49] bg-transparent",
              onClick: I
            }
          ),
          /* @__PURE__ */ o(
            "div",
            {
              className: b("absolute z-50 min-w-full", {
                hidden: !y,
                "top-full": !h || h === Ht.Bottom,
                "bottom-full": h === Ht.Top
              }),
              children: /* @__PURE__ */ o(Kc, { children: c.map((k) => /* @__PURE__ */ o(
                Tl,
                {
                  onClick: () => _(k),
                  hideBottomBorder: !0,
                  children: /* @__PURE__ */ o(xn, { option: k })
                },
                typeof k == "string" ? k : k.id
              )) })
            }
          )
        ] })
      }
    );
  }
);
function xn({ option: e }) {
  return typeof e == "string" ? e : "renderLabel" in e ? e.renderLabel() : e.label;
}
var lt = /* @__PURE__ */ ((e) => (e.Asc = "asc", e.Desc = "desc", e))(lt || {});
function Yc({
  label: e,
  columnKey: t,
  hasSort: r,
  hasCheckbox: n,
  isChecked: a,
  isIndeterminate: i,
  isContentCentered: c,
  onSortClick: s,
  onCheckboxChange: d,
  sortOrder: f
}) {
  const g = () => {
    const y = f === lt.Asc ? lt.Desc : lt.Asc;
    s && s(t, y);
  }, h = "table-header-text-color", x = "text-label-lg", w = r ? f === lt.Asc ? /* @__PURE__ */ o(un, { className: "shrink-0" }) : f === lt.Desc ? /* @__PURE__ */ o(fl, { className: "shrink-0" }) : /* @__PURE__ */ o(un, { className: "invisible shrink-0 group-hover:visible" }) : null;
  return /* @__PURE__ */ o(
    "th",
    {
      onClick: r ? g : void 0,
      className: b(
        "state-layer table-cell-border-color group relative h-14 border-b px-md after:pointer-events-none",
        {
          "cursor-pointer": r
        }
      ),
      children: /* @__PURE__ */ C(
        "div",
        {
          className: b(
            "flex flex-row items-center gap-1 [&_svg]:h-4 [&_svg]:w-4",
            h,
            x,
            {
              "justify-center": c
            }
          ),
          children: [
            n ? /* @__PURE__ */ o(
              Zn,
              {
                isChecked: a,
                isIndeterminate: i,
                onCheckedChange: d
              }
            ) : /* @__PURE__ */ o(
              "span",
              {
                className: b({
                  "text-left": !c
                }),
                children: e
              }
            ),
            w
          ]
        }
      )
    }
  );
}
var Ne = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e))(Ne || {});
const qc = {
  [Ne.Outlined]: "bg-transparent",
  [Ne.Filled]: "search-bg-color-filled"
}, Qc = {
  [Ne.Outlined]: "border-l border-r border-t search-border-color",
  [Ne.Filled]: "search-bg-color-filled"
}, Jc = {
  [Ne.Outlined]: "rounded-b-3xl border-b border-l border-r search-border-color search-suggestion-bg-color",
  [Ne.Filled]: "rounded-b-3xl search-bg-color-filled"
};
function Ad({
  searchValue: e,
  suggestions: t,
  onSearchValueChange: r,
  onSuggestionClick: n,
  placeholder: a,
  isLoading: i = !1,
  type: c = Ne.Outlined,
  renderSuggestion: s
}) {
  const d = le(null), f = le(null), [g, h] = he(!0), [x, w] = he(null);
  function y(L) {
    const _ = L.target.value;
    r(_);
  }
  de(() => {
    const L = (_) => {
      var I;
      _.key === "Escape" && (h(!1), (I = d.current) == null || I.blur());
    };
    return document.addEventListener("keydown", L), () => {
      document.removeEventListener("keydown", L);
    };
  }, []), de(() => {
    const L = (_) => {
      var k;
      const I = d == null ? void 0 : d.current;
      !I || I.contains(_ == null ? void 0 : _.target) || (k = f.current) != null && k.contains(_.target) || h(!1);
    };
    return document.addEventListener("click", L, !0), document.addEventListener("touchstart", L, !0), () => {
      document.removeEventListener("click", L, !0), document.removeEventListener("touchstart", L, !0);
    };
  }, [d]);
  const p = g && t && t.length > 0, S = p ? b(
    "rounded-t-3xl border-b",
    c === Ne.Outlined ? "[&:not(.dark_*,.names_*)]:border-b-transparent" : "border-b-transparent"
  ) : c === Ne.Outlined ? "rounded-3xl border-b" : "rounded-full", E = Qc[c], D = qc[c], N = Jc[c], T = (L) => {
    var _;
    n == null || n(L), r(""), h(!1), w(null), (_ = d.current) == null || _.blur();
  }, P = (L) => {
    t && (t == null ? void 0 : t.length) > 0 && (L.key === "ArrowDown" ? (L.preventDefault(), w(
      (_) => _ === null || _ >= t.length - 1 ? 0 : _ + 1
    )) : L.key === "ArrowUp" ? (L.preventDefault(), w(
      (_) => _ === null || _ <= 0 ? t.length - 1 : _ - 1
    )) : L.key === "Enter" && (L.preventDefault(), x !== null && t[x] ? T(t[x]) : t.length === 1 && T(t[0])));
  };
  return /* @__PURE__ */ C("div", { className: "relative w-full", children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: b(
          "search-text-color flex items-center overflow-hidden px-md py-sm [&_svg]:h-6 [&_svg]:w-6",
          S,
          E
        ),
        children: [
          /* @__PURE__ */ o(
            "input",
            {
              ref: d,
              type: "text",
              value: e,
              onChange: y,
              onKeyDown: P,
              onFocus: () => h(!0),
              placeholder: a,
              className: b(
                "search-placeholder-color w-full flex-1 outline-none",
                D
              )
            }
          ),
          /* @__PURE__ */ o(dl, {})
        ]
      }
    ),
    p && s && /* @__PURE__ */ C(
      "div",
      {
        ref: f,
        className: b(
          "absolute left-0 top-full flex w-full flex-col items-center overflow-hidden",
          N
        ),
        children: [
          /* @__PURE__ */ o(Ol, { width: "w-11/12" }),
          i ? /* @__PURE__ */ o("div", { className: "px-md py-sm", children: /* @__PURE__ */ o(Hn, { className: "animate-spin" }) }) : t.map((L, _) => /* @__PURE__ */ o(
            "div",
            {
              onClick: () => T(L),
              onMouseEnter: () => w(_),
              className: b(
                "w-full cursor-pointer px-md py-sm",
                x === _ ? "search-selected-index-bg-color" : ""
              ),
              children: s(L, _)
            },
            L.id
          ))
        ]
      }
    )
  ] });
}
var yt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Outlined = "outlined", e.Filled = "filled", e))(yt || {}), Ke = /* @__PURE__ */ ((e) => (e.Placeholder = "placeholder", e.BgSolid = "bg-solid", e.BgWhite = "bg-white", e.BgTransparent = "bg-transparent", e))(Ke || {}), mt = /* @__PURE__ */ ((e) => (e.Rounded = "rounded", e.SquareRounded = "square-rounded", e))(mt || {}), zt = /* @__PURE__ */ ((e) => (e.Link = "link", e.SupportingText = "supporting-text", e.Button = "button", e))(zt || {});
const es = "cursor-default opacity-40", wn = "h-10 w-10", yn = {
  [mt.SquareRounded]: `${wn} rounded-md`,
  [mt.Rounded]: `${wn} rounded-full`
}, ts = {
  [Ke.Placeholder]: "",
  [Ke.BgSolid]: "card-image-bg-solid",
  [Ke.BgWhite]: "card-image-bg-white",
  [Ke.BgTransparent]: ""
}, rs = {
  [yt.Default]: "border border-transparent",
  [yt.Outlined]: "border border-shader-neutral-light-8 dark:border-shader-primary-dark-8 p-xs",
  [yt.Filled]: "border border-transparent card-filled-bg p-xs"
};
function Rd({
  isDisabled: e = !1,
  type: t = yt.Default,
  isHoverable: r,
  onClick: n,
  children: a,
  testId: i
}) {
  function c() {
    e || n == null || n();
  }
  return /* @__PURE__ */ o(
    "div",
    {
      onClick: c,
      className: b(
        "relative inline-flex w-full items-center gap-3 rounded-xl px-sm py-xs",
        rs[t],
        {
          "state-layer": r || !e && n,
          [es]: e,
          "cursor-pointer": n
        }
      ),
      "data-testid": i,
      children: a
    }
  );
}
function Dd({
  type: e,
  onClick: t,
  subtitle: r,
  title: n,
  icon: a,
  iconAfterText: i,
  buttonType: c,
  buttonDisabled: s
}) {
  function d(f) {
    t && (f.stopPropagation(), t());
  }
  return e === zt.Link ? /* @__PURE__ */ o(
    "div",
    {
      onClick: d,
      className: "card-action-link-color shrink-0 [&_svg]:h-5 [&_svg]:w-5",
      children: a || /* @__PURE__ */ o(kr, {})
    }
  ) : e === zt.SupportingText ? /* @__PURE__ */ C("div", { className: "shrink-0 text-right", children: [
    n && /* @__PURE__ */ o("div", { className: "card-action-title-color font-inter text-label-md", children: n }),
    r && /* @__PURE__ */ o("div", { className: "card-action-subtitle-color font-inter text-label-sm", children: r })
  ] }) : e === zt.Button ? /* @__PURE__ */ o("div", { className: "shrink-0", children: /* @__PURE__ */ o(
    ge,
    {
      type: c || W.Outlined,
      size: ie.Small,
      text: n,
      onClick: d,
      icon: a,
      iconAfterText: i,
      disabled: s
    }
  ) }) : null;
}
function ns({ variant: e = mt.Rounded }) {
  return e === mt.Rounded ? /* @__PURE__ */ o(as, {}) : /* @__PURE__ */ o(os, {});
}
function as() {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ C("g", { "clip-path": "url(#clip0_880_55185)", children: [
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint0_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "url(#paint1_linear_880_55185)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: [
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: "paint0_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ o("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: "paint1_linear_880_55185",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ o("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o("clipPath", { id: "clip0_880_55185", children: /* @__PURE__ */ o(
            "path",
            {
              d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function os() {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [
        /* @__PURE__ */ C("g", { "clip-path": "url(#clip0_880_55190)", children: [
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "#5B9CFE"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint0_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "url(#paint1_linear_880_55190)",
              "fill-opacity": "0.2"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H32C36.1421 0.5 39.5 3.85786 39.5 8V32C39.5 36.1421 36.1421 39.5 32 39.5H8C3.85786 39.5 0.5 36.1421 0.5 32V8Z",
              stroke: "#002F6D",
              "stroke-opacity": "0.08"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: [
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: "paint0_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "29.5238",
              y2: "22.381",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o("stop", { offset: "0.990135", "stop-opacity": "0" }),
                /* @__PURE__ */ o("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "linearGradient",
            {
              id: "paint1_linear_880_55190",
              x1: "20",
              y1: "0",
              x2: "11.4286",
              y2: "9.04762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ o("stop", { offset: "0.9999", "stop-opacity": "0" }),
                /* @__PURE__ */ o("stop", { offset: "1" })
              ]
            }
          ),
          /* @__PURE__ */ o("clipPath", { id: "clip0_880_55190", children: /* @__PURE__ */ o(
            "path",
            {
              d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
              fill: "white"
            }
          ) })
        ] })
      ]
    }
  );
}
function Td({
  type: e = Ke.BgSolid,
  shape: t = mt.Rounded,
  url: r,
  children: n
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: b(
        yn[t],
        ts[e],
        "flex shrink-0 items-center justify-center  overflow-hidden"
      ),
      children: [
        e === Ke.Placeholder && !n && /* @__PURE__ */ o(ns, { variant: t }),
        r && !n && /* @__PURE__ */ o(
          "img",
          {
            src: r,
            className: b(yn[t], "object-cover"),
            alt: "Card Image"
          }
        ),
        n
      ]
    }
  );
}
function Ld({
  title: e,
  subtitle: t,
  clickableAction: r,
  icon: n,
  isTextTruncated: a,
  tooltipText: i,
  tooltipPosition: c
}) {
  const s = (d) => {
    d == null || d.stopPropagation();
  };
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("flex w-full flex-col", {
        truncate: a
      }),
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: b("flex flex-row items-center gap-x-xxs", {
              "grow-1": a
            }),
            children: [
              /* @__PURE__ */ o(
                "div",
                {
                  className: b("card-body-title-color font-inter text-title-md", {
                    truncate: a
                  }),
                  children: e
                }
              ),
              i ? /* @__PURE__ */ o(vt, { text: i, position: c, children: n }) : /* @__PURE__ */ o("div", { className: "flex items-center", children: n }),
              r && /* @__PURE__ */ o("div", { onClick: s, className: "flex items-center", children: r })
            ]
          }
        ),
        t && /* @__PURE__ */ o(
          "div",
          {
            className: b("card-body-subtitle-color font-inter text-body-md", {
              truncate: a
            }),
            children: t
          }
        )
      ]
    }
  );
}
var ke = /* @__PURE__ */ ((e) => (e.Default = "default", e.Highlight = "highlight", e.Secondary = "secondary", e))(ke || {}), _e = /* @__PURE__ */ ((e) => (e.Default = "default", e.Large = "large", e))(_e || {});
const is = {
  [ke.Default]: "display-stats-bg-default",
  [ke.Highlight]: "display-stats-bg-highlight",
  [ke.Secondary]: "display-stats-bg-secondary"
}, ls = {
  [ke.Default]: "display-stats-text-default",
  [ke.Highlight]: "display-stats-text-highlight",
  [ke.Secondary]: "display-stats-text-secondary"
}, cs = {
  [_e.Default]: "gap-y-sm",
  [_e.Large]: "gap-y-md"
}, ss = {
  [_e.Default]: "text-title-md",
  [_e.Large]: "text-headline-sm"
}, us = {
  [_e.Default]: "text-label-md",
  [_e.Large]: "text-label-lg"
}, ds = {
  [_e.Default]: "text-label-sm",
  [_e.Large]: "text-label-md"
};
function Id({
  label: e,
  tooltipPosition: t,
  tooltipText: r,
  value: n,
  supportingLabel: a,
  type: i = ke.Default,
  size: c = _e.Default,
  icon: s,
  copyText: d,
  onCopySuccess: f,
  onCopyError: g
}) {
  const h = is[i], x = cs[c], w = ls[i], y = ss[c], p = ds[c], S = us[c];
  async function E(D) {
    if (navigator.clipboard && d)
      try {
        await navigator.clipboard.writeText(d), f == null || f(D, d);
      } catch (N) {
        console.error("Failed to copy:", N), g == null || g(N, d);
      }
  }
  return /* @__PURE__ */ C(
    "div",
    {
      className: b(
        "flex h-full w-full flex-col justify-between rounded-2xl p-md--rs",
        h,
        x,
        w
      ),
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: b("flex flex-row items-center", {
              "w-full justify-between": s
            }),
            children: [
              /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-xxs", children: [
                /* @__PURE__ */ o("span", { className: b(p, "whitespace-pre-line"), children: e }),
                r && /* @__PURE__ */ o(vt, { text: r, position: t, children: /* @__PURE__ */ o(tr, { className: "opacity-40" }) })
              ] }),
              s && /* @__PURE__ */ o("span", { className: "display-stats-icon-color", children: s })
            ]
          }
        ),
        /* @__PURE__ */ C("div", { className: "flex w-full flex-row items-baseline gap-xxs", children: [
          /* @__PURE__ */ o("span", { className: b("break-all", y), children: n }),
          a && /* @__PURE__ */ o("span", { className: b("opacity-40", S), children: a }),
          d && /* @__PURE__ */ o("div", { className: "self-center", children: /* @__PURE__ */ o(ce, { onClick: E, children: /* @__PURE__ */ o(Mr, { className: "display-stats-copy-icon-color" }) }) })
        ] })
      ]
    }
  );
}
function Pd({
  onIconClick: e,
  onClick: t,
  icon: r = /* @__PURE__ */ o($n, {}),
  assetTitle: n,
  isHoverable: a = !0,
  ...i
}) {
  const c = (d) => {
    e == null || e(d), d == null || d.stopPropagation();
  }, s = !("src" in i);
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("relative aspect-square w-full overflow-hidden rounded-xl", {
        "group cursor-pointer": a
      }),
      onClick: t,
      children: [
        !s && /* @__PURE__ */ o(Kl, { ...i }),
        s && i.renderAsset,
        a && /* @__PURE__ */ o("div", { className: "absolute left-0 top-0 h-full w-full bg-cover bg-center bg-no-repeat group-hover:bg-shader-neutral-light-48 group-hover:transition group-hover:duration-300 group-hover:ease-in-out group-hover:names:bg-shader-inverted-light-48 group-hover:dark:bg-shader-primary-dark-48" }),
        a && e && /* @__PURE__ */ o(
          ce,
          {
            className: "visual-asset-icon-color absolute right-2 top-2 h-9 w-9 cursor-pointer rounded-full p-xs opacity-0 transition-opacity duration-300 group-hover:bg-shader-neutral-light-72 group-hover:opacity-100 [&_svg]:h-5 [&_svg]:w-5",
            onClick: c,
            children: r
          }
        ),
        a && n && /* @__PURE__ */ o("div", { className: "absolute bottom-0 flex items-center justify-center p-xs opacity-0 transition-opacity duration-300 group-hover:opacity-100", children: /* @__PURE__ */ o("span", { className: "visual-asset-title-color text-title-md", children: n }) })
      ]
    }
  );
}
function Me(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function fs(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ga(...e) {
  return (t) => e.forEach((r) => fs(r, t));
}
function Qe(...e) {
  return v.useCallback(ga(...e), e);
}
function hs(e, t) {
  const r = v.createContext(t);
  function n(i) {
    const { children: c, ...s } = i, d = v.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ o(r.Provider, { value: d, children: c });
  }
  function a(i) {
    const c = v.useContext(r);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return n.displayName = e + "Provider", [n, a];
}
function ms(e, t = []) {
  let r = [];
  function n(i, c) {
    const s = v.createContext(c), d = r.length;
    r = [...r, c];
    function f(h) {
      const { scope: x, children: w, ...y } = h, p = (x == null ? void 0 : x[e][d]) || s, S = v.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ o(p.Provider, { value: S, children: w });
    }
    function g(h, x) {
      const w = (x == null ? void 0 : x[e][d]) || s, y = v.useContext(w);
      if (y) return y;
      if (c !== void 0) return c;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return f.displayName = i + "Provider", [f, g];
  }
  const a = () => {
    const i = r.map((c) => v.createContext(c));
    return function(s) {
      const d = (s == null ? void 0 : s[e]) || i;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: d } }),
        [s, d]
      );
    };
  };
  return a.scopeName = e, [n, vs(a, ...t)];
}
function vs(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const c = n.reduce((s, { useScope: d, scopeName: f }) => {
        const h = d(i)[`__scope${f}`];
        return { ...s, ...h };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var Qt = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
}, gs = v.useId || (() => {
}), ps = 0;
function wr(e) {
  const [t, r] = v.useState(gs());
  return Qt(() => {
    e || r((n) => n ?? String(ps++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Ye(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function bs({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, a] = xs({ defaultProp: t, onChange: r }), i = e !== void 0, c = i ? e : n, s = Ye(r), d = v.useCallback(
    (f) => {
      if (i) {
        const h = typeof f == "function" ? f(e) : f;
        h !== e && s(h);
      } else
        a(f);
    },
    [i, e, a, s]
  );
  return [c, d];
}
function xs({
  defaultProp: e,
  onChange: t
}) {
  const r = v.useState(e), [n] = r, a = v.useRef(n), i = Ye(t);
  return v.useEffect(() => {
    a.current !== n && (i(n), a.current = n);
  }, [n, a, i]), r;
}
var Ur = v.forwardRef((e, t) => {
  const { children: r, ...n } = e, a = v.Children.toArray(r), i = a.find(ys);
  if (i) {
    const c = i.props.children, s = a.map((d) => d === i ? v.Children.count(c) > 1 ? v.Children.only(null) : v.isValidElement(c) ? c.props.children : null : d);
    return /* @__PURE__ */ o(Tr, { ...n, ref: t, children: v.isValidElement(c) ? v.cloneElement(c, void 0, s) : null });
  }
  return /* @__PURE__ */ o(Tr, { ...n, ref: t, children: r });
});
Ur.displayName = "Slot";
var Tr = v.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (v.isValidElement(r)) {
    const a = Cs(r);
    return v.cloneElement(r, {
      ...Ss(n, r.props),
      // @ts-ignore
      ref: t ? ga(t, a) : a
    });
  }
  return v.Children.count(r) > 1 ? v.Children.only(null) : null;
});
Tr.displayName = "SlotClone";
var ws = ({ children: e }) => /* @__PURE__ */ o(Ze, { children: e });
function ys(e) {
  return v.isValidElement(e) && e.type === ws;
}
function Ss(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Cs(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Es = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Oe = Es.reduce((e, t) => {
  const r = v.forwardRef((n, a) => {
    const { asChild: i, ...c } = n, s = i ? Ur : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ o(s, { ...c, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Ns(e, t) {
  e && Pn.flushSync(() => e.dispatchEvent(t));
}
function _s(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ye(e);
  v.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var Os = "DismissableLayer", Lr = "dismissableLayer.update", As = "dismissableLayer.pointerDownOutside", Rs = "dismissableLayer.focusOutside", Sn, pa = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ba = v.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: c,
      onDismiss: s,
      ...d
    } = e, f = v.useContext(pa), [g, h] = v.useState(null), x = (g == null ? void 0 : g.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, w] = v.useState({}), y = Qe(t, (_) => h(_)), p = Array.from(f.layers), [S] = [...f.layersWithOutsidePointerEventsDisabled].slice(-1), E = p.indexOf(S), D = g ? p.indexOf(g) : -1, N = f.layersWithOutsidePointerEventsDisabled.size > 0, T = D >= E, P = Ls((_) => {
      const I = _.target, k = [...f.branches].some((q) => q.contains(I));
      !T || k || (a == null || a(_), c == null || c(_), _.defaultPrevented || s == null || s());
    }, x), L = Is((_) => {
      const I = _.target;
      [...f.branches].some((q) => q.contains(I)) || (i == null || i(_), c == null || c(_), _.defaultPrevented || s == null || s());
    }, x);
    return _s((_) => {
      D === f.layers.size - 1 && (n == null || n(_), !_.defaultPrevented && s && (_.preventDefault(), s()));
    }, x), v.useEffect(() => {
      if (g)
        return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (Sn = x.body.style.pointerEvents, x.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(g)), f.layers.add(g), Cn(), () => {
          r && f.layersWithOutsidePointerEventsDisabled.size === 1 && (x.body.style.pointerEvents = Sn);
        };
    }, [g, x, r, f]), v.useEffect(() => () => {
      g && (f.layers.delete(g), f.layersWithOutsidePointerEventsDisabled.delete(g), Cn());
    }, [g, f]), v.useEffect(() => {
      const _ = () => w({});
      return document.addEventListener(Lr, _), () => document.removeEventListener(Lr, _);
    }, []), /* @__PURE__ */ o(
      Oe.div,
      {
        ...d,
        ref: y,
        style: {
          pointerEvents: N ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Me(e.onFocusCapture, L.onFocusCapture),
        onBlurCapture: Me(e.onBlurCapture, L.onBlurCapture),
        onPointerDownCapture: Me(
          e.onPointerDownCapture,
          P.onPointerDownCapture
        )
      }
    );
  }
);
ba.displayName = Os;
var Ds = "DismissableLayerBranch", Ts = v.forwardRef((e, t) => {
  const r = v.useContext(pa), n = v.useRef(null), a = Qe(t, n);
  return v.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ o(Oe.div, { ...e, ref: a });
});
Ts.displayName = Ds;
function Ls(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ye(e), n = v.useRef(!1), a = v.useRef(() => {
  });
  return v.useEffect(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let d = function() {
          xa(
            As,
            r,
            f,
            { discrete: !0 }
          );
        };
        const f = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = d, t.addEventListener("click", a.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Is(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ye(e), n = v.useRef(!1);
  return v.useEffect(() => {
    const a = (i) => {
      i.target && !n.current && xa(Rs, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Cn() {
  const e = new CustomEvent(Lr);
  document.dispatchEvent(e);
}
function xa(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), n ? Ns(a, i) : a.dispatchEvent(i);
}
var yr = "focusScope.autoFocusOnMount", Sr = "focusScope.autoFocusOnUnmount", En = { bubbles: !1, cancelable: !0 }, Ps = "FocusScope", wa = v.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...c
  } = e, [s, d] = v.useState(null), f = Ye(a), g = Ye(i), h = v.useRef(null), x = Qe(t, (p) => d(p)), w = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (n) {
      let p = function(N) {
        if (w.paused || !s) return;
        const T = N.target;
        s.contains(T) ? h.current = T : Ie(h.current, { select: !0 });
      }, S = function(N) {
        if (w.paused || !s) return;
        const T = N.relatedTarget;
        T !== null && (s.contains(T) || Ie(h.current, { select: !0 }));
      }, E = function(N) {
        if (document.activeElement === document.body)
          for (const P of N)
            P.removedNodes.length > 0 && Ie(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", S);
      const D = new MutationObserver(E);
      return s && D.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", S), D.disconnect();
      };
    }
  }, [n, s, w.paused]), v.useEffect(() => {
    if (s) {
      _n.add(w);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const E = new CustomEvent(yr, En);
        s.addEventListener(yr, f), s.dispatchEvent(E), E.defaultPrevented || (ks(Us(ya(s)), { select: !0 }), document.activeElement === p && Ie(s));
      }
      return () => {
        s.removeEventListener(yr, f), setTimeout(() => {
          const E = new CustomEvent(Sr, En);
          s.addEventListener(Sr, g), s.dispatchEvent(E), E.defaultPrevented || Ie(p ?? document.body, { select: !0 }), s.removeEventListener(Sr, g), _n.remove(w);
        }, 0);
      };
    }
  }, [s, f, g, w]);
  const y = v.useCallback(
    (p) => {
      if (!r && !n || w.paused) return;
      const S = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, E = document.activeElement;
      if (S && E) {
        const D = p.currentTarget, [N, T] = Ms(D);
        N && T ? !p.shiftKey && E === T ? (p.preventDefault(), r && Ie(N, { select: !0 })) : p.shiftKey && E === N && (p.preventDefault(), r && Ie(T, { select: !0 })) : E === D && p.preventDefault();
      }
    },
    [r, n, w.paused]
  );
  return /* @__PURE__ */ o(Oe.div, { tabIndex: -1, ...c, ref: x, onKeyDown: y });
});
wa.displayName = Ps;
function ks(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Ie(n, { select: t }), document.activeElement !== r) return;
}
function Ms(e) {
  const t = ya(e), r = Nn(t, e), n = Nn(t.reverse(), e);
  return [r, n];
}
function ya(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Nn(e, t) {
  for (const r of e)
    if (!Bs(r, { upTo: t })) return r;
}
function Bs(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Fs(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ie(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Fs(e) && t && e.select();
  }
}
var _n = Vs();
function Vs() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = On(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = On(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function On(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Us(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ws = "Portal", Sa = v.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [a, i] = v.useState(!1);
  Qt(() => i(!0), []);
  const c = r || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return c ? ui.createPortal(/* @__PURE__ */ o(Oe.div, { ...n, ref: t }), c) : null;
});
Sa.displayName = Ws;
function js(e, t) {
  return v.useReducer((r, n) => t[r][n] ?? r, e);
}
var nr = (e) => {
  const { present: t, children: r } = e, n = Gs(t), a = typeof r == "function" ? r({ present: n.isPresent }) : v.Children.only(r), i = Qe(n.ref, Hs(a));
  return typeof r == "function" || n.isPresent ? v.cloneElement(a, { ref: i }) : null;
};
nr.displayName = "Presence";
function Gs(e) {
  const [t, r] = v.useState(), n = v.useRef({}), a = v.useRef(e), i = v.useRef("none"), c = e ? "mounted" : "unmounted", [s, d] = js(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const f = Bt(n.current);
    i.current = s === "mounted" ? f : "none";
  }, [s]), Qt(() => {
    const f = n.current, g = a.current;
    if (g !== e) {
      const x = i.current, w = Bt(f);
      e ? d("MOUNT") : w === "none" || (f == null ? void 0 : f.display) === "none" ? d("UNMOUNT") : d(g && x !== w ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, d]), Qt(() => {
    if (t) {
      const f = (h) => {
        const w = Bt(n.current).includes(h.animationName);
        h.target === t && w && Pn.flushSync(() => d("ANIMATION_END"));
      }, g = (h) => {
        h.target === t && (i.current = Bt(n.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((f) => {
      f && (n.current = getComputedStyle(f)), r(f);
    }, [])
  };
}
function Bt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Hs(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Cr = 0;
function $s() {
  v.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? An()), document.body.insertAdjacentElement("beforeend", e[1] ?? An()), Cr++, () => {
      Cr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Cr--;
    };
  }, []);
}
function An() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Ce = function() {
  return Ce = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Ce.apply(this, arguments);
};
function Ca(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function zs(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Xt = "right-scroll-bar-position", Kt = "width-before-scroll-bar", Xs = "with-scroll-bars-hidden", Ks = "--removed-body-scroll-bar-size";
function Er(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Zs(e, t) {
  var r = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Ys = typeof window < "u" ? v.useLayoutEffect : v.useEffect, Rn = /* @__PURE__ */ new WeakMap();
function qs(e, t) {
  var r = Zs(null, function(n) {
    return e.forEach(function(a) {
      return Er(a, n);
    });
  });
  return Ys(function() {
    var n = Rn.get(r);
    if (n) {
      var a = new Set(n), i = new Set(e), c = r.current;
      a.forEach(function(s) {
        i.has(s) || Er(s, null);
      }), i.forEach(function(s) {
        a.has(s) || Er(s, c);
      });
    }
    Rn.set(r, e);
  }, [e]), r;
}
function Qs(e) {
  return e;
}
function Js(e, t) {
  t === void 0 && (t = Qs);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var c = t(i, n);
      return r.push(c), function() {
        r = r.filter(function(s) {
          return s !== c;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var c = r;
        r = [], c.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var c = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), c = r;
      }
      var d = function() {
        var g = c;
        c = [], g.forEach(i);
      }, f = function() {
        return Promise.resolve().then(d);
      };
      f(), r = {
        push: function(g) {
          c.push(g), f();
        },
        filter: function(g) {
          return c = c.filter(g), r;
        }
      };
    }
  };
  return a;
}
function eu(e) {
  e === void 0 && (e = {});
  var t = Js(null);
  return t.options = Ce({ async: !0, ssr: !1 }, e), t;
}
var Ea = function(e) {
  var t = e.sideCar, r = Ca(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return v.createElement(n, Ce({}, r));
};
Ea.isSideCarExport = !0;
function tu(e, t) {
  return e.useMedium(t), Ea;
}
var Na = eu(), Nr = function() {
}, ar = v.forwardRef(function(e, t) {
  var r = v.useRef(null), n = v.useState({
    onScrollCapture: Nr,
    onWheelCapture: Nr,
    onTouchMoveCapture: Nr
  }), a = n[0], i = n[1], c = e.forwardProps, s = e.children, d = e.className, f = e.removeScrollBar, g = e.enabled, h = e.shards, x = e.sideCar, w = e.noIsolation, y = e.inert, p = e.allowPinchZoom, S = e.as, E = S === void 0 ? "div" : S, D = e.gapMode, N = Ca(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = x, P = qs([r, t]), L = Ce(Ce({}, N), a);
  return v.createElement(
    v.Fragment,
    null,
    g && v.createElement(T, { sideCar: Na, removeScrollBar: f, shards: h, noIsolation: w, inert: y, setCallbacks: i, allowPinchZoom: !!p, lockRef: r, gapMode: D }),
    c ? v.cloneElement(v.Children.only(s), Ce(Ce({}, L), { ref: P })) : v.createElement(E, Ce({}, L, { className: d, ref: P }), s)
  );
});
ar.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ar.classNames = {
  fullWidth: Kt,
  zeroRight: Xt
};
var ru = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function nu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ru();
  return t && e.setAttribute("nonce", t), e;
}
function au(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ou(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var iu = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = nu()) && (au(t, r), ou(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, lu = function() {
  var e = iu();
  return function(t, r) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, _a = function() {
  var e = lu(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, cu = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _r = function(e) {
  return parseInt(e || "", 10) || 0;
}, su = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_r(r), _r(n), _r(a)];
}, uu = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return cu;
  var t = su(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, du = _a(), ft = "data-scroll-locked", fu = function(e, t, r, n) {
  var a = e.left, i = e.top, c = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Xs, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(ft, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xt, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Kt, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Xt, " .").concat(Xt, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Kt, " .").concat(Kt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ft, `] {
    `).concat(Ks, ": ").concat(s, `px;
  }
`);
}, Dn = function() {
  var e = parseInt(document.body.getAttribute(ft) || "0", 10);
  return isFinite(e) ? e : 0;
}, hu = function() {
  v.useEffect(function() {
    return document.body.setAttribute(ft, (Dn() + 1).toString()), function() {
      var e = Dn() - 1;
      e <= 0 ? document.body.removeAttribute(ft) : document.body.setAttribute(ft, e.toString());
    };
  }, []);
}, mu = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  hu();
  var i = v.useMemo(function() {
    return uu(a);
  }, [a]);
  return v.createElement(du, { styles: fu(i, !t, a, r ? "" : "!important") });
}, Ir = !1;
if (typeof window < "u")
  try {
    var Ft = Object.defineProperty({}, "passive", {
      get: function() {
        return Ir = !0, !0;
      }
    });
    window.addEventListener("test", Ft, Ft), window.removeEventListener("test", Ft, Ft);
  } catch {
    Ir = !1;
  }
var nt = Ir ? { passive: !1 } : !1, vu = function(e) {
  return e.tagName === "TEXTAREA";
}, Oa = function(e, t) {
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !vu(e) && r[t] === "visible")
  );
}, gu = function(e) {
  return Oa(e, "overflowY");
}, pu = function(e) {
  return Oa(e, "overflowX");
}, Tn = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = Aa(e, n);
    if (a) {
      var i = Ra(e, n), c = i[1], s = i[2];
      if (c > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, bu = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, xu = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, Aa = function(e, t) {
  return e === "v" ? gu(t) : pu(t);
}, Ra = function(e, t) {
  return e === "v" ? bu(t) : xu(t);
}, wu = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, yu = function(e, t, r, n, a) {
  var i = wu(e, window.getComputedStyle(t).direction), c = i * n, s = r.target, d = t.contains(s), f = !1, g = c > 0, h = 0, x = 0;
  do {
    var w = Ra(e, s), y = w[0], p = w[1], S = w[2], E = p - S - i * y;
    (y || E) && Aa(e, s) && (h += E, x += y), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !d && s !== document.body || // self content
    d && (t.contains(s) || t === s)
  );
  return (g && Math.abs(h) < 1 || !g && Math.abs(x) < 1) && (f = !0), f;
}, Vt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ln = function(e) {
  return [e.deltaX, e.deltaY];
}, In = function(e) {
  return e && "current" in e ? e.current : e;
}, Su = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Cu = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Eu = 0, at = [];
function Nu(e) {
  var t = v.useRef([]), r = v.useRef([0, 0]), n = v.useRef(), a = v.useState(Eu++)[0], i = v.useState(_a)[0], c = v.useRef(e);
  v.useEffect(function() {
    c.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = zs([e.lockRef.current], (e.shards || []).map(In), !0).filter(Boolean);
      return p.forEach(function(S) {
        return S.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(S) {
          return S.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(p, S) {
    if ("touches" in p && p.touches.length === 2)
      return !c.current.allowPinchZoom;
    var E = Vt(p), D = r.current, N = "deltaX" in p ? p.deltaX : D[0] - E[0], T = "deltaY" in p ? p.deltaY : D[1] - E[1], P, L = p.target, _ = Math.abs(N) > Math.abs(T) ? "h" : "v";
    if ("touches" in p && _ === "h" && L.type === "range")
      return !1;
    var I = Tn(_, L);
    if (!I)
      return !0;
    if (I ? P = _ : (P = _ === "v" ? "h" : "v", I = Tn(_, L)), !I)
      return !1;
    if (!n.current && "changedTouches" in p && (N || T) && (n.current = P), !P)
      return !0;
    var k = n.current || P;
    return yu(k, S, p, k === "h" ? N : T);
  }, []), d = v.useCallback(function(p) {
    var S = p;
    if (!(!at.length || at[at.length - 1] !== i)) {
      var E = "deltaY" in S ? Ln(S) : Vt(S), D = t.current.filter(function(P) {
        return P.name === S.type && (P.target === S.target || S.target === P.shadowParent) && Su(P.delta, E);
      })[0];
      if (D && D.should) {
        S.cancelable && S.preventDefault();
        return;
      }
      if (!D) {
        var N = (c.current.shards || []).map(In).filter(Boolean).filter(function(P) {
          return P.contains(S.target);
        }), T = N.length > 0 ? s(S, N[0]) : !c.current.noIsolation;
        T && S.cancelable && S.preventDefault();
      }
    }
  }, []), f = v.useCallback(function(p, S, E, D) {
    var N = { name: p, delta: S, target: E, should: D, shadowParent: _u(E) };
    t.current.push(N), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== N;
      });
    }, 1);
  }, []), g = v.useCallback(function(p) {
    r.current = Vt(p), n.current = void 0;
  }, []), h = v.useCallback(function(p) {
    f(p.type, Ln(p), p.target, s(p, e.lockRef.current));
  }, []), x = v.useCallback(function(p) {
    f(p.type, Vt(p), p.target, s(p, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return at.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: x
    }), document.addEventListener("wheel", d, nt), document.addEventListener("touchmove", d, nt), document.addEventListener("touchstart", g, nt), function() {
      at = at.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", d, nt), document.removeEventListener("touchmove", d, nt), document.removeEventListener("touchstart", g, nt);
    };
  }, []);
  var w = e.removeScrollBar, y = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    y ? v.createElement(i, { styles: Cu(a) }) : null,
    w ? v.createElement(mu, { gapMode: e.gapMode }) : null
  );
}
function _u(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Ou = tu(Na, Nu);
var Da = v.forwardRef(function(e, t) {
  return v.createElement(ar, Ce({}, e, { ref: t, sideCar: Ou }));
});
Da.classNames = ar.classNames;
var Au = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ot = /* @__PURE__ */ new WeakMap(), Ut = /* @__PURE__ */ new WeakMap(), Wt = {}, Or = 0, Ta = function(e) {
  return e && (e.host || Ta(e.parentNode));
}, Ru = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = Ta(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Du = function(e, t, r, n) {
  var a = Ru(t, Array.isArray(e) ? e : [e]);
  Wt[r] || (Wt[r] = /* @__PURE__ */ new WeakMap());
  var i = Wt[r], c = [], s = /* @__PURE__ */ new Set(), d = new Set(a), f = function(h) {
    !h || s.has(h) || (s.add(h), f(h.parentNode));
  };
  a.forEach(f);
  var g = function(h) {
    !h || d.has(h) || Array.prototype.forEach.call(h.children, function(x) {
      if (s.has(x))
        g(x);
      else
        try {
          var w = x.getAttribute(n), y = w !== null && w !== "false", p = (ot.get(x) || 0) + 1, S = (i.get(x) || 0) + 1;
          ot.set(x, p), i.set(x, S), c.push(x), p === 1 && y && Ut.set(x, !0), S === 1 && x.setAttribute(r, "true"), y || x.setAttribute(n, "true");
        } catch (E) {
          console.error("aria-hidden: cannot operate on ", x, E);
        }
    });
  };
  return g(t), s.clear(), Or++, function() {
    c.forEach(function(h) {
      var x = ot.get(h) - 1, w = i.get(h) - 1;
      ot.set(h, x), i.set(h, w), x || (Ut.has(h) || h.removeAttribute(n), Ut.delete(h)), w || h.removeAttribute(r);
    }), Or--, Or || (ot = /* @__PURE__ */ new WeakMap(), ot = /* @__PURE__ */ new WeakMap(), Ut = /* @__PURE__ */ new WeakMap(), Wt = {});
  };
}, Tu = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = Au(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Du(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Wr = "Dialog", [La, kd] = ms(Wr), [Lu, pe] = La(Wr), Ia = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: i,
    modal: c = !0
  } = e, s = v.useRef(null), d = v.useRef(null), [f = !1, g] = bs({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ o(
    Lu,
    {
      scope: t,
      triggerRef: s,
      contentRef: d,
      contentId: wr(),
      titleId: wr(),
      descriptionId: wr(),
      open: f,
      onOpenChange: g,
      onOpenToggle: v.useCallback(() => g((h) => !h), [g]),
      modal: c,
      children: r
    }
  );
};
Ia.displayName = Wr;
var Pa = "DialogTrigger", ka = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = pe(Pa, r), i = Qe(t, a.triggerRef);
    return /* @__PURE__ */ o(
      Oe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Hr(a.open),
        ...n,
        ref: i,
        onClick: Me(e.onClick, a.onOpenToggle)
      }
    );
  }
);
ka.displayName = Pa;
var jr = "DialogPortal", [Iu, Ma] = La(jr, {
  forceMount: void 0
}), Ba = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: a } = e, i = pe(jr, t);
  return /* @__PURE__ */ o(Iu, { scope: t, forceMount: r, children: v.Children.map(n, (c) => /* @__PURE__ */ o(nr, { present: r || i.open, children: /* @__PURE__ */ o(Sa, { asChild: !0, container: a, children: c }) })) });
};
Ba.displayName = jr;
var Jt = "DialogOverlay", Fa = v.forwardRef(
  (e, t) => {
    const r = Ma(Jt, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = pe(Jt, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ o(nr, { present: n || i.open, children: /* @__PURE__ */ o(Pu, { ...a, ref: t }) }) : null;
  }
);
Fa.displayName = Jt;
var Pu = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = pe(Jt, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ o(Da, { as: Ur, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ o(
        Oe.div,
        {
          "data-state": Hr(a.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), qe = "DialogContent", Va = v.forwardRef(
  (e, t) => {
    const r = Ma(qe, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = pe(qe, e.__scopeDialog);
    return /* @__PURE__ */ o(nr, { present: n || i.open, children: i.modal ? /* @__PURE__ */ o(ku, { ...a, ref: t }) : /* @__PURE__ */ o(Mu, { ...a, ref: t }) });
  }
);
Va.displayName = qe;
var ku = v.forwardRef(
  (e, t) => {
    const r = pe(qe, e.__scopeDialog), n = v.useRef(null), a = Qe(t, r.contentRef, n);
    return v.useEffect(() => {
      const i = n.current;
      if (i) return Tu(i);
    }, []), /* @__PURE__ */ o(
      Ua,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Me(e.onCloseAutoFocus, (i) => {
          var c;
          i.preventDefault(), (c = r.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: Me(e.onPointerDownOutside, (i) => {
          const c = i.detail.originalEvent, s = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Me(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Mu = v.forwardRef(
  (e, t) => {
    const r = pe(qe, e.__scopeDialog), n = v.useRef(!1), a = v.useRef(!1);
    return /* @__PURE__ */ o(
      Ua,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var c, s;
          (c = e.onCloseAutoFocus) == null || c.call(e, i), i.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), i.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var d, f;
          (d = e.onInteractOutside) == null || d.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const c = i.target;
          ((f = r.triggerRef.current) == null ? void 0 : f.contains(c)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), Ua = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, ...c } = e, s = pe(qe, r), d = v.useRef(null), f = Qe(t, d);
    return $s(), /* @__PURE__ */ C(Ze, { children: [
      /* @__PURE__ */ o(
        wa,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ o(
            ba,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Hr(s.open),
              ...c,
              ref: f,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(Ze, { children: [
        /* @__PURE__ */ o(Bu, { titleId: s.titleId }),
        /* @__PURE__ */ o(Vu, { contentRef: d, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Gr = "DialogTitle", Wa = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = pe(Gr, r);
    return /* @__PURE__ */ o(Oe.h2, { id: a.titleId, ...n, ref: t });
  }
);
Wa.displayName = Gr;
var ja = "DialogDescription", Ga = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = pe(ja, r);
    return /* @__PURE__ */ o(Oe.p, { id: a.descriptionId, ...n, ref: t });
  }
);
Ga.displayName = ja;
var Ha = "DialogClose", $a = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = pe(Ha, r);
    return /* @__PURE__ */ o(
      Oe.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Me(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
$a.displayName = Ha;
function Hr(e) {
  return e ? "open" : "closed";
}
var za = "DialogTitleWarning", [Md, Xa] = hs(za, {
  contentName: qe,
  titleName: Gr,
  docsSlug: "dialog"
}), Bu = ({ titleId: e }) => {
  const t = Xa(za), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return v.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Fu = "DialogDescriptionWarning", Vu = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Xa(Fu).contentName}}.`;
  return v.useEffect(() => {
    var i;
    const a = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Uu = Ia, Wu = ka, ju = Ba, Ka = Fa, Za = Va, $r = Wa, Gu = Ga, Hu = $a, $u = "VisuallyHidden", Ya = v.forwardRef(
  (e, t) => /* @__PURE__ */ o(
    Oe.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Ya.displayName = $u;
var zu = Ya, ct = /* @__PURE__ */ ((e) => (e.Center = "center", e.Right = "right", e))(ct || {});
const Bd = ({
  open: e,
  onOpenChange: t,
  children: r,
  ...n
}) => /* @__PURE__ */ o(Uu, { open: e, onOpenChange: (i) => {
  const c = document.querySelector(".toast-layer:hover");
  !i && c || t == null || t(i);
}, ...n, children: r }), Fd = Wu, Xu = Hu, qa = v.forwardRef(({ showCloseIcon: e, position: t, ...r }, n) => /* @__PURE__ */ o(
  Ka,
  {
    ref: n,
    className: b(
      " dialog-overlay-bg absolute h-full w-full backdrop-blur-md names:backdrop-blur-lg"
    ),
    ...r,
    children: /* @__PURE__ */ o(Xu, { className: b("fixed right-3 top-3", { hidden: !e }), children: /* @__PURE__ */ o(Et, { className: "button-text-color-neutral" }) })
  }
));
qa.displayName = Ka.displayName;
const Ku = v.forwardRef((e, t) => /* @__PURE__ */ o(
  "div",
  {
    className: b("inset-0 z-[99999]", e.isFixedPosition ? "fixed" : "absolute"),
    ref: t,
    children: /* @__PURE__ */ o("div", { className: "relative h-full w-full", children: e.children })
  }
)), Zu = v.forwardRef(
  ({
    className: e,
    containerId: t,
    showCloseOnOverlay: r,
    children: n,
    position: a = ct.Center,
    customWidth: i = "w-80 max-w-[85vw] md:w-96",
    isFixedPosition: c = a === ct.Right,
    ...s
  }, d) => {
    const [f, g] = he(
      void 0
    );
    de(() => {
      const y = t ? document.getElementById(t) : void 0;
      g(y ?? void 0);
    }, [t]);
    const h = a === ct.Right ? "overflow-hidden right-0 h-screen top-0 w-full" : "overflow-y-auto overflow-x-hidden left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl", x = a === ct.Right ? "md:w-96 max-w-[500px]" : i, w = a === ct.Right ? "h-screen" : "max-h-[80vh] h-full";
    return /* @__PURE__ */ o(ju, { container: f, children: /* @__PURE__ */ C(Ku, { isFixedPosition: c, children: [
      /* @__PURE__ */ o(qa, { showCloseIcon: r, position: a }),
      /* @__PURE__ */ C(
        Za,
        {
          ref: d,
          className: b(
            "dialog-content-bg dialog-outline absolute flex flex-col justify-center",
            h,
            x
          ),
          ...s,
          children: [
            /* @__PURE__ */ C(zu, { children: [
              /* @__PURE__ */ o($r, {}),
              /* @__PURE__ */ o(Gu, {})
            ] }),
            /* @__PURE__ */ o("div", { className: b("flex flex-1 flex-col", w), children: n })
          ]
        }
      )
    ] }) });
  }
);
Zu.displayName = Za.displayName;
const Yu = v.forwardRef((e, t) => /* @__PURE__ */ o(
  $r,
  {
    ref: t,
    className: "dialog-title-color font-inter text-title-lg",
    ...e
  }
));
Yu.displayName = $r.displayName;
const qu = v.forwardRef(
  (e, t) => /* @__PURE__ */ o(
    "div",
    {
      ref: t,
      className: "dialog-body-color flex-1 overflow-y-auto p-md--rs text-body-sm",
      ...e
    }
  )
);
qu.displayName = "DialogBody";
const Qa = ci({
  isHeaderChecked: !1,
  selectedRowIndexes: /* @__PURE__ */ new Set(),
  isHeaderIndeterminate: !1
}), Ja = () => si(Qa);
function Qu({
  children: e,
  selectedRowIndexes: t,
  rowIndexes: r,
  ...n
}) {
  const a = r.length === t.size, i = !a && t.size > 0;
  return /* @__PURE__ */ o(
    Qa.Provider,
    {
      value: {
        ...n,
        isHeaderChecked: a,
        selectedRowIndexes: t,
        isHeaderIndeterminate: i
      },
      children: e
    }
  );
}
function Vd({
  paginationOptions: e,
  action: t,
  supportingLabel: r,
  selectedRowIndexes: n = /* @__PURE__ */ new Set(),
  rowIndexes: a,
  children: i,
  pageSizeSelector: c,
  heightFull: s = !1
}) {
  return /* @__PURE__ */ o(Qu, { selectedRowIndexes: n, rowIndexes: a, children: /* @__PURE__ */ C("div", { className: b("w-full", { "h-full": s }), children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: b("overflow-auto", {
          "h-full": s
        }),
        children: /* @__PURE__ */ o(
          "table",
          {
            className: b("w-full table-auto", {
              "h-full": s
            }),
            children: i
          }
        )
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        className: b("flex w-full items-center gap-sm pt-md", {
          hidden: !r && !e && !t,
          "flex-col justify-between sm:flex-row": e,
          "justify-end": !e && t
        }),
        children: [
          (e || t) && /* @__PURE__ */ C("div", { className: "flex gap-2", children: [
            e && /* @__PURE__ */ C(Ze, { children: [
              /* @__PURE__ */ o(
                ge,
                {
                  type: W.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ o(nl, {}),
                  disabled: !e.hasFirst,
                  onClick: e.onFirst
                }
              ),
              /* @__PURE__ */ o(
                ge,
                {
                  type: W.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ o(Qi, {}),
                  disabled: !e.hasPrev,
                  onClick: e.onPrev
                }
              ),
              /* @__PURE__ */ o(
                ge,
                {
                  type: W.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ o(kr, {}),
                  disabled: !e.hasNext,
                  onClick: e.onNext
                }
              ),
              /* @__PURE__ */ o(
                ge,
                {
                  type: W.Secondary,
                  size: ie.Small,
                  icon: /* @__PURE__ */ o(al, {}),
                  disabled: !e.hasLast,
                  onClick: e.onLast
                }
              )
            ] }),
            t && t
          ] }),
          r || c ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-sm", children: [
            r && /* @__PURE__ */ o("span", { className: "table-text-color text-label-md", children: r }),
            c && /* @__PURE__ */ o("div", { className: "ml-2", children: c })
          ] }) : null
        ]
      }
    )
  ] }) });
}
function Ud(e) {
  return /* @__PURE__ */ o(ge, { type: W.Secondary, size: ie.Small, ...e });
}
function Wd({ children: e }) {
  return /* @__PURE__ */ o("thead", { children: e });
}
function jd({
  children: e,
  leading: t
}) {
  return /* @__PURE__ */ C("tr", { children: [
    t,
    e
  ] });
}
const Ju = "table-text-color", ed = "text-body-md";
function Gd({ children: e }) {
  return /* @__PURE__ */ o("tbody", { className: b(Ju, ed), children: e });
}
function Hd({
  rowIndex: e,
  onCheckboxChange: t
}) {
  const { selectedRowIndexes: r } = Ja();
  return /* @__PURE__ */ o(Zc, { isContentCentered: !0, children: /* @__PURE__ */ o(
    Zn,
    {
      onCheckedChange: (n) => {
        t(n.target.checked);
      },
      isChecked: r.has(e)
    }
  ) });
}
function $d({ onCheckboxChange: e }) {
  const { isHeaderChecked: t, isHeaderIndeterminate: r } = Ja();
  return /* @__PURE__ */ o(
    Yc,
    {
      isContentCentered: !0,
      hasCheckbox: !0,
      onCheckboxChange: (n) => {
        e(n.target.checked);
      },
      isChecked: t,
      columnKey: 1,
      isIndeterminate: r
    }
  );
}
function zd({
  items: e,
  activeId: t,
  onClickItem: r,
  isCollapsible: n = !1,
  onToggleNavbar: a
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: b("flex h-fit w-full", {
        "flex-col px-md py-xs sm:h-full sm:w-auto sm:px-none sm:py-xl": n
      }),
      children: [
        n && /* @__PURE__ */ C("div", { className: "flex w-full items-center justify-between sm:mb-[48px] sm:flex-col", children: [
          /* @__PURE__ */ o("div", { className: "flex justify-center [&_svg]:h-[38px] [&_svg]:w-[38px]", children: /* @__PURE__ */ o(ol, { className: "navbar-icon-color" }) }),
          /* @__PURE__ */ o(
            "div",
            {
              className: "state-layer navbar-icon-color relative rounded-full p-xs hover:cursor-pointer sm:hidden [&_svg]:h-6 [&_svg]:w-6",
              onClick: a,
              children: /* @__PURE__ */ o(cl, {})
            }
          )
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            className: b({
              "flex w-full justify-between px-sm py-xxs": !n,
              "hidden sm:flex sm:flex-col sm:gap-2": n
            }),
            children: e.map((i) => /* @__PURE__ */ o(
              "div",
              {
                className: b("flex items-center", {
                  "px-xs py-xxs": !n,
                  "py-xxs pl-xs pr-sm": n
                }),
                "data-testid": `nav-${i.id}`,
                children: /* @__PURE__ */ o(
                  va,
                  {
                    ...i,
                    isSelected: i.id === t,
                    onClick: (c) => {
                      i.onClick && i.onClick(c), i.isDisabled || r(i.id);
                    }
                  }
                )
              },
              i.id
            ))
          }
        )
      ]
    }
  );
}
function Xd({
  items: e,
  activeId: t,
  onClickItem: r,
  isOpen: n,
  onToggleNavbar: a
}) {
  return /* @__PURE__ */ C(Ze, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        onClick: a,
        className: b("duration-800 transition-opacity ease-out", {
          "opacity-1 fixed left-0 top-0 h-full w-full bg-shader-neutral-light-72": n,
          "-translate-x-full opacity-0": !n
        })
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: b(
          "z-999 rounded-tb-3xl navbar-slideout-bg fixed left-0 top-0 h-full w-11/12 rounded-tr-3xl px-lg py-lg transition-transform duration-300 ease-out",
          {
            "translate-x-0": n,
            "-translate-x-full": !n
          }
        ),
        children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ o("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ o(
            ge,
            {
              type: W.Ghost,
              onClick: a,
              icon: /* @__PURE__ */ o(Gn, {})
            }
          ) }),
          e.map((i) => /* @__PURE__ */ o(
            va,
            {
              ...i,
              type: Vr.Vertical,
              isSelected: i.id === t,
              onClick: () => {
                r(i.id), a && a();
              }
            },
            i.id
          ))
        ] })
      }
    )
  ] });
}
const td = "accordion-icon-color transition-transform ease-linear";
function Kd({
  onToggle: e,
  children: t,
  isExpanded: r,
  hideArrow: n
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      onClick: e,
      className: b(
        "state-layer relative flex cursor-pointer items-center justify-between gap-md overflow-hidden rounded-xl py-sm--rs",
        {
          "pr-md--rs": !n
        }
      ),
      children: [
        t,
        !n && /* @__PURE__ */ o("div", { className: "[&_svg]:h-5 [&_svg]:w-5", children: /* @__PURE__ */ o(
          ge,
          {
            type: W.Ghost,
            icon: /* @__PURE__ */ o(
              qi,
              {
                className: b(td, {
                  "rotate-180": r
                })
              }
            )
          }
        ) })
      ]
    }
  );
}
function Zd({
  isExpanded: e,
  children: t
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: b({
        hidden: !e
      }),
      children: t
    }
  );
}
function Yd({
  children: e,
  hideBorder: t
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: b("accordion-bg rounded-xl", {
        "accordion-border-color border": !t
      }),
      children: e
    }
  );
}
function qd(e, t = 6, r = 6) {
  return e.length > t + r ? `${e.slice(0, t)}...${e.slice(-r)}` : e;
}
export {
  Yd as Accordion,
  Zd as AccordionContent,
  Kd as AccordionHeader,
  Ed as Account,
  Xl as Address,
  Kl as AssetMediaRenderer,
  Yt as Badge,
  te as BadgeType,
  ge as Button,
  er as ButtonHtmlType,
  ld as ButtonPill,
  sd as ButtonSegment,
  st as ButtonSegmentType,
  ie as ButtonSize,
  W as ButtonType,
  ce as ButtonUnstyled,
  Rd as Card,
  Dd as CardAction,
  zt as CardActionType,
  Ld as CardBody,
  Td as CardImage,
  yt as CardType,
  Zn as Checkbox,
  xd as Chip,
  Dr as ChipSize,
  K as ChipType,
  Bd as Dialog,
  qu as DialogBody,
  Xu as DialogClose,
  Zu as DialogContent,
  ct as DialogPosition,
  Yu as DialogTitle,
  Fd as DialogTrigger,
  Id as DisplayStats,
  _e as DisplayStatsSize,
  ke as DisplayStatsType,
  Ol as Divider,
  Xe as DividerType,
  Kc as Dropdown,
  Ht as DropdownPosition,
  fd as Header,
  mi as IOTA_NAMES_COLOR_PALETTE,
  hi as IOTA_PRIMITIVES_COLOR_PALETTE,
  Yn as Image,
  mt as ImageShape,
  Ke as ImageType,
  Il as ImageWithFallback,
  md as InfoBox,
  Gt as InfoBoxStyle,
  Te as InfoBoxType,
  Sd as Input,
  Se as InputType,
  ud as KeyValueInfo,
  dd as LabelText,
  fe as LabelTextSize,
  Tl as ListItem,
  gd as LoadingIndicator,
  Ll as MediaFallback,
  zd as Navbar,
  va as NavbarItem,
  Vr as NavbarItemType,
  Xd as NavbarSlideout,
  hd as Panel,
  Bl as Placeholder,
  cd as RadioButton,
  hc as Resize,
  vi as SHADER_COLOR_PALETTE,
  De as ScreenSize,
  Ad as Search,
  Ne as SearchBarType,
  wd as SegmentedButton,
  ut as SegmentedButtonType,
  Od as Select,
  $t as SelectSize,
  pd as Skeleton,
  vd as Snackbar,
  Ee as SnackbarType,
  Vd as Table,
  Ud as TableActionButton,
  Gd as TableBody,
  Zc as TableCellBase,
  _d as TableCellPlaceholder,
  Nd as TableCellText,
  Wd as TableHeader,
  Yc as TableHeaderCell,
  lt as TableHeaderCellSortOrder,
  $d as TableHeaderCheckbox,
  jd as TableRow,
  Hd as TableRowCheckbox,
  Cd as TextArea,
  yd as Title,
  ht as TitleSize,
  bd as Toggle,
  Rr as ToggleLabelPosition,
  Be as ToggleSize,
  vt as Tooltip,
  He as TooltipPosition,
  fi as UIKitTheme,
  jt as ValueSize,
  Ul as Video,
  Pd as VisualAssetCard,
  qn as VisualAssetType,
  qd as truncate,
  od as uiKitResponsivePreset,
  id as uiKitStaticPreset
};
//# sourceMappingURL=index.es.js.map
